import './Buildings.css';
import React, { useEffect, useState, useRef } from 'react';
import {
    faFileArrowUp, faPaperPlane, faSearch, faTimes, faCircleCheck, faPlus, faXmark, faBuilding,
    faUserShield, faEdit, faHistory, faMapLocationDot, faCalendarAlt
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, Link } from 'react-router-dom';
import { db, storage } from '../../../firebase.init';
import { collection, getDocs, query, where, updateDoc, collectionGroup, orderBy } from 'firebase/firestore';
import defaultImage from '../../Assets/default.png'
import redLogo from '../../Assets/Fire-Checked-logo.png'
import greenDoor from '../../Assets/Fire-Checked-green.png'
import redDoor from '../../Assets/Fire-Checked-red.png'
import yellowDoor from '../../Assets/Fire-Checked-yellow.png'
import greyDoor from '../../Assets/Fire-Checked-grey.png'
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../../firebase.init';
import logo from '../../Assets/logo.png'
import Modal from 'react-modal';
import { doc, setDoc, addDoc } from 'firebase/firestore';
import profile from '../../Assets/default-profile.png'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ref, uploadBytesResumable, getDownloadURL, uploadBytes } from "firebase/storage";
import { Carousel } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ClipLoader from "react-spinners/ClipLoader";
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { Modal as BootstrapModal, Offcanvas, Tabs, Tab, Button, Form, Col, Row } from 'react-bootstrap';
import { format, set } from 'date-fns';
import { MapContainer, TileLayer, Marker, Popup, Tooltip, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
import Flatpickr from "react-flatpickr";
// import 'flatpickr/dist/flatpickr.min.css';
import "flatpickr/dist/themes/material_red.css";
import ContactModal from '../../ContactModal/ContactModal';
import { useUserRole } from '../../../hooks/useUserRole';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet/dist/images/marker-shadow.png",
});

const MapRefresher = ({ trigger }) => {
    const map = useMap();
    useEffect(() => {
        if (trigger) {
            setTimeout(() => {
                map.invalidateSize();
            }, 100);
        }
    }, [trigger, map]);

    return null;
};

const RESTORE_KEY = 'buildings_restore';

const readRestore = () => {
    try { return JSON.parse(sessionStorage.getItem(RESTORE_KEY)) || null; }
    catch (e) { return null; }
};

const findScrollerHops = (card) => {
    let el = card.parentElement;
    let hops = 1;
    while (el) {
        const oy = getComputedStyle(el).overflowY;
        if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && el.scrollHeight > el.clientHeight + 1) {
            return hops;
        }
        el = el.parentElement;
        hops++;
    }
    return 0;
};

const scrollerFor = (card, hops) => {
    if (!hops) return window;
    let el = card;
    for (let i = 0; i < hops && el; i++) el = el.parentElement;
    return el || window;
};

const Buildings = () => {
    const location = useLocation();
    // const [data, setData] = useState(location.state?.reportsData || []);
    const [data, setData] = useState({});
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        if (location.state?.reportsData) {
            setData(location.state.reportsData);

            navigate(location.pathname, { replace: true });
        }
    }, []);

    const [filterType, setFilterType] = useState(location.state?.filterType || []);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const toastId = useRef(null);

    const [user, loadingAuth] = useAuthState(auth);
    const [showNumber, setShowNumber] = useState(false);
    const [filters, setFilters] = useState(() => {
        return JSON.parse(sessionStorage.getItem("filters")) || {
            floor: "",
            clientName: "",
            searchText: ""
        };
    });

    const [nestedReports, setNestedReports] = useState({});
    const [reportInfos, setReportInfos] = useState([]);
    const [doorReportInfos, setDoorReportInfos] = useState([]);
    const [buildingsWithPreviousReports, setBuildingsWithPreviousReports] = useState([]);
    const [inspectorInfos, setInspectorInfos] = useState([]);
    const [error, setError] = useState(null);
    const [signOffCount, setSignOffCount] = useState(0);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedBuildings, setSelectedBuildings] = useState([]);
    const [selectedInspector, setSelectedInspector] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);

    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [selectedBuildings1, setSelectedBuildings1] = useState([]);
    const [selectedBuildingsDoor, setSelectedBuildingsDoor] = useState([]);
    const [selectedInspector1, setSelectedInspector1] = useState(null);
    const [currentStep1, setCurrentStep1] = useState(1);
    const [inspectionDate, setInspectionDate] = useState('');

    const [emails, setEmails] = useState([]);
    const [doorFilters, setDoorFilters] = useState({});
    const [resiDoorFilters, setResiDoorFilters] = useState({});
    const [selectedData, setSelectedData] = useState({});

    const [key, setKey] = useState('communal');
    const [activeSlide, setActiveSlide] = useState(() => readRestore()?.slide || 0);

    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [emailTouched, setEmailTouched] = useState(false);
    const [showInviteModal, setShowInviteModal] = useState(false);

    const [isHovered, setIsHovered] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const isMobile = window.innerWidth < 768;
    const formRef = useRef(null);
    const [activeTab, setActiveTab] = useState('section1');

    const [locations, setLocations] = useState([]);
    const [showMapModal, setShowMapModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const [building1, setBuilding1] = useState("");
    const [building2, setBuilding2] = useState("");
    const [compare, setCompare] = useState(false);
    const [showCompare, setShowCompare] = useState(false);
    const [compareResult, setCompareResult] = useState(null);
    const [activeTab1, setActiveTab1] = useState('issues');
    const [activeTab2, setActiveTab2] = useState('issues');

    let grandTrueCount = 0;
    let grandFalseCount = 0;
    let grandReqAttentionCount = 0;
    let grandHasAccessCount = 0;

    const handleCompare = () => {
        if (!building1 || !building2 || building1 === building2) {
            alert("Please select two different buildings.");
            return;
        }

        const loc1 = locations.find(l => l.name === building1);
        const loc2 = locations.find(l => l.name === building2);

        if (!loc1 || !loc2) {
            alert("One or both buildings not found in location data.");
            return;
        }

        const result = {
            loc1,
            loc2,
        };

        setCompare(true);
        setCompareResult(result);
    };

    const getCombinedIssues = (buildingData, data) => {

        if (!buildingData || !data) {
            return [];
        }

        const buildingName = buildingData.name || buildingData.buildingName;
        if (!buildingName) return [];

        const fullBuildingData = data[buildingName];
        if (!fullBuildingData) return [];

        const issuesMap = new Map();

        const predefinedOptions = {
            doorCertification: [
                "Replace Non-Certified Door",
                "Internal Door Inspection",
            ],
            doorCloseAsIntented: [
                "Repair door closer",
                "Adjust door closer",
                "Install new door closer",
                "Replace door closer"
            ],
            doorStrips: [
                "Install intumescent strips",
                "Replace damaged intumescent strip",
                "Replace missing intumescent strip",
                "Intumescent strip installed incorrectly"
            ],
            hingesWorking: [
                "Screws missing from hinge",
                "Tighten hinge",
                "Replace broken hinge"
            ],
            hingesFireRating: ["Replace non-complaint hinge"],
            door: [
                "Replace damaged door",
                "Repair damaged door",
                "Replace non-complaint door"
            ],
            frame: [
                "Repair damaged door frame",
                "Replace damaged door frame"
            ],
            glass: [
                "Replace cracked glass",
                "Replace non-complaint glass",
                "Refix loose glazing beads",
                "Replace glazing beads"
            ],
            ventilation: [
                "Clear blocked ventilation gaps",
                "Install additional gaps if needed"
            ],
            gaps: [
                "Adjust Gap - Lock",
                "Adjust Gap - Hinge",
                "Adjust Gap - Top",
                "Adjust Gap - Bottom"
            ],
        };

        const predefinedList = Object.values(predefinedOptions).flat();

        const parseWorkNeeded = (text) => {
            if (!text || !text.trim()) return [];

            let cleanText = text.replace(/\s+/g, ' ').trim();
            const extracted = [];

            const adjustGapRegex = /Adjust Gap\s*-\s*([A-Za-z, ]+)/gi;
            let match;

            while ((match = adjustGapRegex.exec(cleanText)) !== null) {
                const parts = match[1]
                    .split(',')
                    .map(p => p.trim())
                    .filter(Boolean);

                parts.forEach(part => {
                    const task = `Adjust Gap - ${part}`;
                    if (predefinedList.includes(task)) {
                        extracted.push(task);
                    }
                });
            }

            cleanText = cleanText.replace(adjustGapRegex, '').trim();

            predefinedList.forEach(opt => {
                const regex = new RegExp(`\\b${opt}\\b`, 'i');
                if (regex.test(cleanText)) {
                    extracted.push(opt);
                    cleanText = cleanText.replace(regex, '').trim();
                }
            });

            if (!extracted.length && cleanText) {
                extracted.push(cleanText);
            }

            return extracted.filter(Boolean);
        };

        const processReports = (reports) => {
            if (!reports || !Array.isArray(reports)) return;

            reports.forEach((door) => {
                const damageMultiples = door.damageMultiples || [];

                if (!door.doorStrips) {
                    addToIssue(issuesMap, 'Intumescent Strips', 'Intumescent strips not working or missing', door);
                }

                if (!damageMultiples.includes("None") && !damageMultiples.includes("Frame Pass") && damageMultiples.includes("Frame")) {
                    addToIssue(issuesMap, 'Frame Condition', 'Frame condition failed - damage or issues with door frame', door);
                }

                if (!damageMultiples.includes("None") && !damageMultiples.includes("Ventilation Gaps Pass") && damageMultiples.includes("Ventilation Gaps")) {
                    addToIssue(issuesMap, 'Sealing Condition', 'Sealing condition failed - ventilation gaps issues', door);
                }

                if (parseInt(door.fD1) > 4) addToIssue(issuesMap, 'Lock Side Gap', 'Lock side gap too large - should be ≤4mm', door);
                if (parseInt(door.fD2) > 4) addToIssue(issuesMap, 'Hinge Side Gap', 'Hinge side gap too large - should be ≤4mm', door);
                if (parseInt(door.fD3) > 4) addToIssue(issuesMap, 'Top Gap', 'Top gap too large - should be ≤4mm', door);
                if (parseInt(door.fD4) > 8) addToIssue(issuesMap, 'Bottom Gap', 'Bottom gap too large - should be ≤8mm', door);

                if (door.doorCloseAsIntented === false || door.doorCloseAsIntented === "No") {
                    addToIssue(issuesMap, 'Door Closer', 'Door closer not working properly', door);
                }

                if (!door.hingesFireRating) {
                    addToIssue(issuesMap, 'Hinges Fire Rating', 'Hinges not fire rated', door);
                }

                if (!door.hingesWorking) {
                    addToIssue(issuesMap, 'Hinges Function', 'Hinges not working properly', door);
                }

                if (door.doorCertif && door.doorCertif.includes('No')) {
                    addToIssue(issuesMap, 'Door Certification', 'Door certification missing', door);
                }

                if (door.workNeeded && door.workNeeded.trim()) {
                    const tasks = parseWorkNeeded(door.workNeeded);
                    tasks.forEach(task => addToIssue(issuesMap, 'Work Needed', task, door));
                }
            });
        };

        processReports(fullBuildingData.doorReports);
        processReports(fullBuildingData.resiReports);

        const finalIssues = Array.from(issuesMap.values()).sort((a, b) => b.count - a.count);

        // finalIssues.forEach((issue, index) => {
        //     console.log(`${index + 1}. ${issue.category}: ${issue.count} doors - "${issue.description}"`);
        // });

        return finalIssues;
    };


    const addToIssue = (issuesMap, category, description, door) => {
        let key;
        if (category.includes('Gap')) {
            key = `${category}_${description}`;
        } else if (category === 'Work Needed') {
            key = `${category}_${description}`;
        } else {
            key = `${category}_${description}`;
        }

        // console.log(`Adding issue: ${category} - "${description}" for door: ${door.doorName || `Door ${door.doorNumber}`}`);

        if (!issuesMap.has(key)) {
            issuesMap.set(key, {
                category,
                description,
                count: 0,
                doors: []
            });
        }

        const issue = issuesMap.get(key);
        issue.count += 1;
        issue.doors.push({
            doorName: door.doorName || `Door ${door.doorNumber}`,
            id: door.id || door._id || door.doorId,
            doorNumber: door.doorNumber
        });

        // console.log(`Issue count now: ${issue.count}`);
    };

    const getCoordinates = async (address) => {
        try {
            const response = await fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(address)}`);
            const data = await response.json();

            if (!data.features || data.features.length === 0) {
                console.warn("No features returned for:", address);
                return null;
            }

            const ukFeature = data.features.find(f => {
                const props = f.properties || {};
                const countryCode = (props.country_code || "").toUpperCase();
                const countryName = (props.country || "").toUpperCase();
                return countryCode === "GB" || countryName === "UNITED KINGDOM" || countryName === "UK";
            });

            if (!ukFeature) {
                console.warn("No UK feature found for:", address);
                return null;
            }

            const [lng, lat] = ukFeature.geometry.coordinates;
            return { lat, lng };

        } catch (error) {
            console.error("Photon geocoding error for address:", address, error);
            return null;
        }
    };

    const getCoordinatesPostcodeIO = async (postcode) => {
        try {
            const res = await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(postcode)}`);
            const data = await res.json();
            if (data.status === 200) {
                return { lat: data.result.latitude, lng: data.result.longitude };
            }
            return null;
        } catch (e) {
            console.error("Postcodes.io error:", e);
            return null;
        }
    };
    const mapRef = useRef();

    const FitBounds = ({ locations, searchTerm }) => {
        const map = useMap();

        useEffect(() => {
            if (!map || !locations?.length) return;

            const term = searchTerm.toLowerCase().trim();

            const filtered = locations.filter((loc) =>
                loc.name?.toLowerCase().includes(term) ||
                loc.city?.toLowerCase().includes(term) ||
                loc.clientName?.toLowerCase().includes(term)
            );

            if (filtered.length === 0) return;

            const bounds = L.latLngBounds(filtered.map((loc) => [loc.lat, loc.lng]));
            map.fitBounds(bounds, { padding: [50, 50] });
        }, [locations, searchTerm, map]);

        return null;
    };


    // edit building info
    const [newBuildingPhoto, setNewBuildingPhoto] = useState(null);
    const [newBuildingLogo, setNewBuildingLogo] = useState(null);

    const [hoverPhoto, setHoverPhoto] = useState(false);
    const [hoverLogo, setHoverLogo] = useState(false);

    const [selectedReport, setSelectedReport] = useState(null);

    const today = new Date();
    const [plannedDate, setPlannedDate] = useState(today);
    const [commDate, setCommDate] = useState(null);
    const [resiDate, setResiDate] = useState(null);

    const [inspectores, setInspectores] = useState([]);
    const [selectedBuildingInspector, setSelectedBuildingInspector] = useState(null);
    const [selectedBuildingType, setSelectedBuildingType] = useState(null);

    const fetchInspectores = async () => {
        try {
            const q = query(collection(db, "users"), where("user_role", "==", "inspector"));
            const snapshot = await getDocs(q);
            const list = snapshot.docs
                .map(doc => ({ value: doc.id, label: doc.data().name }))
                .filter(u => u.label);
            setInspectores(list);
        } catch (err) {
            console.error("Error fetching inspectores:", err);
        } finally {
            setLoading(false);
        }
    }

    const [autoSchedule, setAutoSchedule] = useState(true);

    useEffect(() => {
        if (!showDetailsModal || !selectedReport) return;

        // console.log(JSON.stringify(selectedReport, null, 2));

        const setValue = (name, value) => {
            const input = document.querySelector(`[name="${name}"]`);
            if (input) input.value = value ?? '';
        };

        setValue('propertySurveyed', selectedReport.buildingName);
        setValue('reportId', selectedReport.reportId);
        setValue('buildingType', selectedReport.buildingType);
        setValue('buildingAddress', selectedReport.clientAddress);
        setValue('buildingCity', selectedReport.city);
        setValue('buildingPostcode', selectedReport.postcode);
        setValue('floors', selectedReport.floors);
        setValue('clientName', selectedReport.clientName);
        setValue('email', selectedReport.email);
        setValue('accountablePerson', selectedReport.personInCharge);
        // setValue('date', selectedReport.date);
        // setValue('nextCommunalSurveyDate', selectedReport.nextDate);
        // setValue('nextResidentialSurveyDate', selectedReport.nextDateResidential);
        setValue('totalCommunalDoors', selectedReport.totalCommunalDoors);
        setValue('totalResiDoors', selectedReport.totalResiDoors);

        setValue('conciergeDetails', selectedReport.conciergeDetails);
        setValue('parkingInfo', selectedReport.parkingInfo);
        setValue('accessInfo', selectedReport.accessInfo);
        setValue('communalMonths', selectedReport.communalMonths);


        if (selectedReport?.completedByUid) {
            const inspectorOption = inspectores.find(
                (i) => i.value === selectedReport.completedByUid
            );

            setSelectedBuildingInspector(
                inspectorOption || {
                    label: selectedReport.completedBy,
                    value: selectedReport.completedByUid
                }
            );
        } else {
            setSelectedBuildingInspector(null);
        }



        if (selectedReport.buildingType) {
            const option = buildingTypeOptions.find(
                (opt) => opt.value === selectedReport.buildingType || opt.label === selectedReport.buildingType
            );
            setSelectedBuildingType(option || { label: selectedReport.buildingType, value: selectedReport.buildingType });
        } else {
            setSelectedBuildingType(null);
        }

        setPlannedDate(selectedReport.date ? new Date(selectedReport.date) : null);
        setCommDate(selectedReport.nextDate ? new Date(selectedReport.nextDate) : null);
        setResiDate(selectedReport.nextDateResidential ? new Date(selectedReport.nextDateResidential) : null);

        setAutoSchedule(selectedReport.autoSchedule !== false);

    }, [showDetailsModal, selectedReport]);


    const handleSubmitDetails = async () => {
        // console.log("Submitting details...");

        if (!formRef.current) {
            console.error("Form reference not found");
            return;
        }

        const formData = new FormData(formRef.current);

        const fieldLabels = {
            propertySurveyed: "Property Surveyed",
            reportId: "Report ID",
            // completedBy: "Report Completed By",
            buildingType: "Building Type",

            // clientAddress: "Client Address",
            // clientCity: "Client City",
            // clientPostcode: "Client Postcode",
            buildingAddress: "Building Address",
            buildingCity: "Building City",
            buildingPostcode: "Building Postcode",
            floors: "Number of Floors",

            clientName: "Client Name",
            email: "Client Email",
            accountablePerson: "Responsible Person",

            // totalCommunalDoors: "Number of Communal Doors",
            // totalResiDoors: "Number of Residential Doors",

            date: "Planned visit date",
            // nextCommunalSurveyDate: "Next Communal Survey Date",
            // nextResidentialSurveyDate: "Next Residential Survey Date",

            conciergeDetails: "Concierge Details",
            parkingInfo: "Parking Info",
            accessInfo: "Access Info",
            communalMonths: "Communal Months Override",
        };

        const requiredFields = Object.keys(fieldLabels);

        const missingFields = requiredFields.filter(field => {

            const value = formData.get(field);
            return !value || value.trim() === '';
        });

        if (missingFields.length > 0) {
            const missingLabels = missingFields.map(field => fieldLabels[field]);
            alert(`Please fill all required fields:\n\n${missingLabels.join("\n")}`);
            return;
        }

        setLoading(true);

        const now = new Date();
        const formattedDate = format(now, 'yyyy-MM-dd HH:mm:ss');

        const buildingPhotoInput = formRef.current.querySelector('#buildingPhoto');
        const logoInput = formRef.current.querySelector('#buildingLogo');
        const contractorCertificateInput = formRef.current.querySelector('#contractorCertificate');

        const buildingPhoto = buildingPhotoInput?.files?.[0] || null;
        const logo = logoInput?.files?.[0] || null;
        const contractorCertificate = contractorCertificateInput?.files?.[0] || null;

        const totalCommunal = parseInt(formData.get('totalCommunalDoors')) || 0;
        const totalResi = parseInt(formData.get('totalResiDoors')) || 0;

        const dateValue = formData.get('date') || '';
        const dateTime = dateValue ? `${dateValue} 10:00:00` : '';

        const data = {
            reportId: formData.get('reportId') || '',
            completedBy: selectedBuildingInspector?.label || '',
            completedByUid: selectedBuildingInspector?.value || '',
            clientName: formData.get('clientName') || '',
            clientAddress: formData.get('buildingAddress') || '',
            client_address: formData.get('clientAddress') || '',
            client_city: formData.get('clientCity') || '',
            client_postcode: formData.get('clientPostcode') || '',
            city: formData.get('buildingCity') || '',
            postcode: formData.get('buildingPostcode') || '',
            buildingName: formData.get('propertySurveyed') || '',
            floors: formData.get('floors') || '',
            buildingType: formData.get('buildingType') || '',
            personInCharge: formData.get('accountablePerson') || '',

            nextDate: formData.get('nextCommunalSurveyDate') || '',
            nextDateResidential: formData.get('nextResidentialSurveyDate') || '',
            // dateCreated: formData.get('date') || '',

            conciergeDetails: formData.get('conciergeDetails') || '',
            parkingInfo: formData.get('parkingInfo') || '',
            accessInfo: formData.get('accessInfo') || '',
            communalMonths: formData.get('communalMonths') || '',

            dateUpdated: formattedDate,
            date: dateTime,
            uid: '',
            // surveryCompleted: false,
            // buildingLink: '',
            // logo: '',
            email: formData.get('email') || '',
            // addedBy: user?.uid || '',
            updatedBy: user?.uid || '',
            totalCommunalDoors: totalCommunal,
            totalResiDoors: totalResi,
            // contractorCertificate: ''
            autoSchedule: autoSchedule,
        };

        if (buildingPhoto) data.buildingLink = '';
        if (logo) data.logo = '';
        if (contractorCertificate) data.contractorCertificate = '';

        try {
            const docRef = selectedReport?.uid
                ? doc(db, "Reports", selectedReport.uid)
                : doc(collection(db, "Reports"));

            await setDoc(docRef, { ...data, uid: docRef.id }, { merge: true });

            if (buildingPhoto) await uploadFile(buildingPhoto, docRef.id, "buildingLink");
            if (logo) await uploadFile(logo, docRef.id, "logo");
            if (contractorCertificate) await uploadFile(contractorCertificate, docRef.id, "contractorCertificate");

            toast.success(
                `Report for ${data.buildingName} ${selectedReport?.uid ? "updated" : "created"} successfully!`,
                {
                    toastId: `report_success_${docRef.id}`,
                    icon: <FontAwesomeIcon icon={faCircleCheck} size="lg" style={{ color: "green" }} />,
                    autoClose: 3000,
                    style: { backgroundColor: "#e6ffed", color: "#064e3b", borderLeft: "4px solid green" },
                }
            );
        } catch (error) {
            console.error("Error saving report:", error);
        } finally {
            setShowDetailsModal(false);
            setLoading(false);

            const name = filters.searchText?.trim();
            if (name) {
                delete loadedDoorsRef.current[name];
            }

            await fetchDoorReports();

            setRefreshKey(prev => prev + 1);
        }

    };


    const uploadFile = async (file, docId, fieldName) => {
        const storageRef = ref(storage, `Reports/${docId}/${fieldName}`);
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);
        await updateDoc(doc(db, "Reports", docId), {
            [fieldName]: downloadURL
        });
    };


    const handleSlideChange = (swiper) => {
        setActiveSlide(swiper.activeIndex);
    };


    const [index, setIndex] = useState(0);
    const [index1, setIndex1] = useState(0);
    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };
    const handleSelect1 = (selectedIndex1, e) => {
        setIndex1(selectedIndex1);
    };

    const handleBuildingFilterChange = (buildingId, filter) => {
        setDoorFilters(prevState => ({
            ...prevState,
            [buildingId]: filter,
        }));
    };
    const handleBuildingFilterChange1 = (buildingId, filter) => {
        setResiDoorFilters(prevState => ({
            ...prevState,
            [buildingId]: filter,
        }));
    };


    const handleRequestClick = () => {
        setShowNumber(!showNumber);
    };
    const handleSignOffClick = () => {
        navigate('/invoices');
    };

    const handleTicketClick = () => {
        navigate('/tickets');
    };

    const goToAdmin = () => {
        if (user) {
            navigate('/admin');
        } else {
            setShowInviteModal(true);
        }
    };

    const goToCalendar = () => {
        if (user) {
            navigate('/calendar');
        } else {
            setShowInviteModal(true);
        }
    };

    //1sttModal
    const addEmail = (email) => {
        if (email.trim() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            if (emails.includes(email.trim())) {
                alert("This email has already been added.");
            } else {
                setEmails([...emails, email.trim()]);
            }
        } else {
            alert("Please enter a valid email.");
        }
    };

    const removeEmail = (index) => {
        setEmails(emails.filter((_, i) => i !== index));
    };

    const resetModal = () => {
        setCurrentStep(1);
        setSelectedBuildings([]);
        setSelectedInspector(null);
        setInspectionDate('');
        setEmails([]);
    }

    const handleBuildingSelection = (buildingId) => {
        // console.log("Selected buildingId:", buildingId);
        setSelectedBuildings((prevSelected) => {
            const isSelected = prevSelected.includes(buildingId);
            const newSelected = isSelected
                ? prevSelected.filter((id) => id !== buildingId)
                : [...prevSelected, buildingId];

            // console.log("Updated Selected Buildings:", newSelected);
            return newSelected;
        });
    };

    let latestReportsByBuilding = {};

    latestReportsByBuilding = Object.values(
        reportInfos.reduce((acc, report) => {
            // if (report.signOff) {
            const buildingName = report.buildingName;
            if (!acc[buildingName] || new Date(report.date) > new Date(acc[buildingName].date)) {
                acc[buildingName] = { ...report, uid: report.uid };
            }
            // }
            return acc;
        }, {})
    );
    // console.log("Latest Reports by Building:", latestReportsByBuilding);

    const handleInspectorSelection = (inspectorId) => {
        if (selectedInspector === inspectorId) {
            setSelectedInspector(null);
        } else {
            setSelectedInspector(inspectorId);
        }
    };


    const handleNextStep = () => {
        if (currentStep === 1 && selectedBuildings.length > 0) {
            // console.log(inspectorInfos);
            setCurrentStep(2);
        }
    };

    const handleBackStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleModalSubmit = async () => {
        setLoading(true);

        if (selectedBuildings.length === 0) {
            setLoading(false);
            alert("Please select at least one building.");
            return;
        }

        if (emails.length === 0 && !selectedInspector) {
            setLoading(false);
            alert("Please select at least one inspector or enter an email");
            return;
        }

        if (emails.length > 0) {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            for (const email of emails) {
                if (!emailPattern.test(email)) {
                    setLoading(false);
                    alert(`Please provide a valid email address: ${email}`);
                    return;
                }
            }
        }

        const selectedBuildingDetails = reportInfos.filter((building) =>
            selectedBuildings.includes(building.uid)
        );

        // console.log('Selected Buildings:', selectedBuildingDetails);
        // console.log('Selected Inspector:', selectedInspector);

        const selectedBuildingNames = selectedBuildingDetails.map(building => building.uid);

        if (user) {
            try {
                await saveSurveyRequestInfoToFirestore(user, selectedBuildingNames, selectedInspector, emails);

                setSelectedBuildings([]);
                setSelectedInspector('');
                setInspectionDate('');
                setIsModalOpen(false);
                setEmails([]);

                toast.info('Survey request saved successfully!',
                    {
                        toastId: 'survey_success',
                        className: 'green-toast',
                        icon: <FontAwesomeIcon icon={faCircleCheck} bounce size="sm" style={{ color: "green", }} />,
                        progressClassName: 'green-progress-bar',
                    }
                );
            } catch (error) {
                console.error("Error saving selected buildings to Firestore:", error);
            }
        }

        setLoading(false);
    };

    const saveSurveyRequestInfoToFirestore = async (authUser, selectedBuildingNames, selectedInspector, emails) => {
        try {
            if (authUser) {
                const userDocRef = doc(db, 'users', authUser.uid);
                const requestedSurveysRef = collection(userDocRef, 'requestedSurveys');

                const surveyData = {
                    selectedBuildings: selectedBuildingNames,
                    enteredEmails: emails,
                    requestedAt: new Date().toUTCString(),
                };

                if (selectedInspector) {
                    surveyData.selectedInspector = {
                        uid: selectedInspector.uid,
                        name: selectedInspector.name,
                        email: selectedInspector.email,
                    };
                }

                await addDoc(requestedSurveysRef, surveyData);
                // console.log("Survey request saved successfully.");
            }
        } catch (error) {
            console.error("Error saving survey request to Firestore:", error);
        }
    };



    //2ndModal
    const resetModal1 = () => {
        setCurrentStep1(1);
        setSelectedBuildings1([]);
        setSelectedBuildingsDoor([]);
        setSelectedInspector1(null);
        setInspectionDate('');
        setEmails([]);
        setDoorFilters([]);
        setSelectedData([]);
        setKey('communal');
    }
    // const handleBuildingSelection1 = (buildingId, building) => {
    //     console.log("Selected buildingId:", buildingId);
    //     setSelectedBuildings1((prevSelected) => {
    //         const isSelected = prevSelected.includes(buildingId);
    //         const newSelected = isSelected
    //             ? prevSelected.filter((id) => id !== buildingId)
    //             : [...prevSelected, buildingId];

    //         console.log("Updated Selected Buildings:", newSelected);
    //         return newSelected;
    //     });
    // };

    // const handleDoorSelection1 = (uid, buildingId, door) => {
    //     console.log("Selected door UID:", uid, "for building ID:", buildingId);

    //     setSelectedBuildingsDoor((prevSelectedDoors) => {
    //         const buildingDoors = prevSelectedDoors[buildingId] || [];

    //         const isDoorSelected = buildingDoors.includes(uid);

    //         const newBuildingDoors = isDoorSelected
    //             ? buildingDoors.filter((doorId) => doorId !== uid)
    //             : [...buildingDoors, uid];

    //         const updatedDoors = {
    //             ...prevSelectedDoors,
    //             [buildingId]: newBuildingDoors,
    //         };

    //         console.log("Updated Selected Doors for Building:", buildingId, newBuildingDoors);

    //         return updatedDoors;
    //     });
    // };

    const handleBuildingSelection1 = (buildingId, building) => {
        // console.log("Selected buildingId:", buildingId);

        setSelectedBuildings1((prevSelected) => {
            const isSelected = prevSelected.includes(buildingId);
            const newSelected = isSelected
                ? prevSelected.filter((id) => id !== buildingId)
                : [...prevSelected, buildingId];

            setSelectedData((prevData) => {
                const updatedData = { ...prevData };

                if (isSelected) {
                    delete updatedData[buildingId];
                } else {
                    updatedData[buildingId] = { building, doors: [] };
                }

                // console.log("Updated Selected Data:", updatedData);
                return updatedData;
            });

            // console.log("Updated Selected Buildings:", newSelected);
            return newSelected;
        });
    };

    const handleDoorSelection1 = (uid, buildingId, door) => {
        // console.log("Selected door UID:", uid, "for building ID:", buildingId);

        setSelectedBuildingsDoor((prevSelectedDoors) => {
            const buildingDoors = prevSelectedDoors[buildingId] || [];

            const isDoorSelected = buildingDoors.includes(uid);

            const newBuildingDoors = isDoorSelected
                ? buildingDoors.filter((doorId) => doorId !== uid)
                : [...buildingDoors, uid];

            setSelectedData((prevData) => {
                const updatedData = { ...prevData };

                const buildingData = updatedData[buildingId] || { doors: [] };

                const updatedDoors = isDoorSelected
                    ? buildingData.doors.filter((d) => d.uid !== uid)
                    : buildingData.doors.some((d) => d.uid === uid)
                        ? buildingData.doors
                        : [...buildingData.doors, door];

                const sortedDoors = updatedDoors.sort((a, b) => {
                    if (a.type === 'communal' && b.type === 'residential') return -1;
                    if (a.type === 'residential' && b.type === 'communal') return 1;
                    return 0;
                });

                updatedData[buildingId] = {
                    ...buildingData,
                    doors: sortedDoors,
                };

                // console.log("Updated Selected Data:", updatedData);

                return updatedData;
            });

            const updatedDoors = {
                ...prevSelectedDoors,
                [buildingId]: newBuildingDoors,
            };

            // console.log("Updated Selected Doors for Building:", buildingId, newBuildingDoors);

            return updatedDoors;
        });
    };


    const handleInspectorSelection1 = (inspector) => {
        if (selectedInspector1 && selectedInspector1.uid === inspector.uid) {
            setSelectedInspector1(null);
        } else {
            setSelectedInspector1(inspector);
        }
    };


    const handleNextStep1 = () => {
        if (currentStep1 < 4 && selectedBuildings1.length > 0) {
            setCurrentStep1(currentStep1 + 1);
        }
    };

    const handleBackStep1 = () => {
        if (currentStep1 > 1) {
            setCurrentStep1(currentStep1 - 1);
        }
    };


    const makePdf = async (user, buildingData, doorIds) => {
        setLoading(true);

        try {
            const doorDataArray = selectedData[buildingData.uid]?.doors || [];
            if (!Array.isArray(doorDataArray)) {
                console.error(`Expected an array for doors in building ${buildingData.uid}, got:`, doorDataArray);
                setLoading(false);
                return null;
            }

            const selectedDoors = doorIds.map((doorId) => {
                const doorData = doorDataArray.find((d) => d.uid === doorId);
                if (!doorData) {
                    console.warn(`Door ID ${doorId} not found for building ID ${buildingData.uid}.`);
                    return null;
                }

                return { ...doorData, buildingName: buildingData.buildingName };
            }).filter(Boolean);

            const payload = {
                doorReports: selectedDoors,
                report: buildingData,
            };

            // console.log("Payload for PDF Export:", payload);

            // const response = await fetch("http://localhost:8080/export-to-pdf", {
            const response = await fetch("https://firechecked-gcp-813451531907.europe-west1.run.app/export-to-pdf", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                const pdfBlob = await response.blob();

                const now = new Date();
                const formattedDate = now.toISOString().replace(/T/, '__').replace(/\..+/, '');
                const formattedTimestamp = formattedDate.replace(/:/g, '_');

                const storageRef = ref(storage, `users/${user.uid}/requestedMaintainence/Report_${formattedTimestamp}.pdf`);
                const uploadTask = uploadBytesResumable(storageRef, pdfBlob);

                const downloadURL = await new Promise((resolve, reject) => {
                    uploadTask.on(
                        "state_changed",
                        (snapshot) => { },
                        (error) => {
                            console.error("Error uploading PDF:", error);
                            reject("Error uploading PDF");
                        },
                        async () => {
                            try {
                                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                                resolve(downloadURL);
                            } catch (error) {
                                console.error("Error getting download URL:", error);
                                reject("Error getting download URL");
                            }
                        }
                    );
                });

                return downloadURL;
            } else {
                throw new Error(`Failed with status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error exporting PDF:", error);
            alert("An error occurred while exporting the PDF.");
            throw error;
        } finally {
            setLoading(false);
        }
    };


    const handleModalSubmit1 = async () => {

        if (selectedBuildings1.length === 0) {
            setLoading(false);
            alert("Please select at least one building.");
            return;
        }

        if (emails.length === 0 && !selectedInspector1) {
            setLoading(false);
            alert("Please select at least one inspector or enter an email");
            return;
        }

        if (emails.some(email => !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email))) {
            setLoading(false);
            alert("Please provide valid email addresses.");
            return;
        }

        const selectedBuildingDetails = latestReportsByBuilding.filter((building) =>
            selectedBuildings1.includes(building.uid)
        );
        const selectedBuildingNames = selectedBuildingDetails.map(building => building.uid);

        if (user) {
            try {
                setLoading(true);
                const pdfLinksByBuilding = await makePdfsForAllBuildings(user, selectedBuildingDetails);

                await saveSurveyRequestInfoToFirestore1(
                    user,
                    selectedBuildingNames,
                    selectedInspector1,
                    emails,
                    pdfLinksByBuilding
                );

                setSelectedBuildings1([]);
                setSelectedBuildingsDoor([]);
                setSelectedInspector('');
                setInspectionDate('');
                setIsModalOpen1(false);
                setEmails([]);
                setDoorFilters([]);
                setSelectedData([]);

                toast.info('Survey maintenance saved successfully!', {
                    toastId: 'survey_success',
                    className: 'green-toast',
                    icon: <FontAwesomeIcon icon={faCircleCheck} bounce size="sm" style={{ color: "green", }} />,
                    progressClassName: 'green-progress-bar',
                });
            } catch (error) {
                console.error("Error saving survey request:", error);
            } finally {
                setLoading(false);
            }
        }

    };


    const makePdfsForAllBuildings = async (authUser, selectedBuildings) => {
        try {
            const pdfPromises = selectedBuildings.map(async (building) => {
                const buildingData = latestReportsByBuilding.find((b) => b.uid === building.uid);
                if (!buildingData) {
                    console.warn(`Building ${building.uid} not found.`);
                    return { buildingId: building.uid, pdfLink: null };
                }

                const doors = selectedBuildingsDoor[building.uid] || [];
                try {
                    const pdfLink = await makePdf(authUser, buildingData, doors);
                    return { buildingId: building.uid, pdfLink };
                } catch (error) {
                    console.error(`Failed to generate PDF for building ${building.uid}:`, error);
                    return { buildingId: building.uid, pdfLink: null };
                }
            });

            const pdfResults = await Promise.all(pdfPromises);
            return pdfResults.reduce((acc, { buildingId, pdfLink }) => {
                acc[buildingId] = pdfLink;
                return acc;
            }, {});
        } catch (error) {
            console.error("Error generating PDFs for all buildings:", error);
            throw error;
        }
    };

    const saveSurveyRequestInfoToFirestore1 = async (authUser, selectedBuildingNames, selectedInspector, emails, pdfLinksByBuilding) => {
        try {
            if (authUser) {
                const userDocRef = doc(db, 'users', authUser.uid);
                const requestedSurveysRef = collection(userDocRef, 'requestedMaintainence');

                const surveyData = {
                    enteredEmails: emails,
                    requestedAt: new Date().toUTCString(),
                    ...(selectedInspector && {
                        selectedInspector: {
                            uid: selectedInspector.uid,
                            name: selectedInspector.name,
                            email: selectedInspector.email,
                        },
                    }),
                };

                const surveyDocRef = await addDoc(requestedSurveysRef, surveyData);

                const buildingPromises = selectedBuildingNames.map(async (buildingId) => {
                    const buildingData = latestReportsByBuilding.find((b) => b.uid === buildingId);
                    if (!buildingData) {
                        console.warn(`Building ID ${buildingId} not found in reports.`);
                        return;
                    }

                    const doors = selectedBuildingsDoor[buildingId] || [];
                    const pdfLink = pdfLinksByBuilding[buildingId] || "";

                    const buildingRef = doc(collection(surveyDocRef, 'selectedBuildings'), buildingId);
                    await setDoc(buildingRef, {
                        building_uid: buildingId,
                        selectedDoors: doors,
                        pdfLink,
                    });
                });

                await Promise.all(buildingPromises);
            }
        } catch (error) {
            console.error("Error saving survey request to Firestore:", error);
            throw error;
        }
    };



    const buildingGroupsRef = useRef(new Map());
    const loadedDoorsRef = useRef({});

    const [buildingGroups, setBuildingGroups] = useState(new Map());
    const [loadedDoors, setLoadedDoors] = useState({});
    const [doorsLoading, setDoorsLoading] = useState({});
    const restoreRef = useRef(undefined);
    if (restoreRef.current === undefined) restoreRef.current = readRestore();
    const initialSlideRef = useRef(restoreRef.current?.slide || 0);

    const [visibleCount, setVisibleCount] = useState(() =>
        Math.max(20, readRestore()?.count || 20)
    );

    const disarmRestore = () => {
        restoreRef.current = null;
        initialSlideRef.current = 0;
        sessionStorage.removeItem(RESTORE_KEY);
    };

    const saveListState = (uid) => {
        const card = document.getElementById(`building-${uid}`);
        const visible = !!card && card.getClientRects().length > 0;
        sessionStorage.setItem(RESTORE_KEY, JSON.stringify({
            uid,
            top: visible ? card.getBoundingClientRect().top : null,
            hops: visible ? findScrollerHops(card) : 0,
            count: visibleCount,
            slide: activeSlide,
        }));
    };
    const [loadingMore, setLoadingMore] = useState(false);
    const [searchSuggestions, setSearchSuggestions] = useState([]);
    const [dataReady, setDataReady] = useState(false);

    useEffect(() => { buildingGroupsRef.current = buildingGroups; }, [buildingGroups]);
    useEffect(() => { loadedDoorsRef.current = loadedDoors; }, [loadedDoors]);

    const isFirstFilterRun = useRef(true);

    useEffect(() => {
        if (!buildingGroups.size || !dataReady) return;

        const timer = setTimeout(() => {
            const hasActiveFilter =
                filters.searchText?.trim().length >= 2 ||
                filters.floor ||
                filters.clientName ||
                filters.personInCharge;

            if (!hasActiveFilter) return;

            const matchingNames = Object.values(data)
                .filter(({ reportInfo }) =>
                    reportInfo?.buildingName &&
                    doesReportMatchFilter(reportInfo, filters)
                )
                .map(({ reportInfo }) => reportInfo.buildingName)
                .filter(name => name && typeof name === 'string')
                .sort((a, b) => a.localeCompare(b))
                .slice(0, 20)
                .filter(name => !loadedDoorsRef.current[name]);

            if (matchingNames.length === 0) return;

            loadDoorsForBatch(matchingNames);
        }, 400);

        return () => clearTimeout(timer);
    }, [
        filters.searchText,
        filters.floor,
        filters.clientName,
        filters.personInCharge,
        dataReady,
        refreshKey
    ]);

    const userData = useUserRole();

    const fetchDoorReports = async () => {
        setLoading(true);
        try {
            const reportsRef = collection(db, 'Reports');
            const { role, uid, user: currentUser } = userData;
            const userEmail = currentUser?.email;

            const combinedDocs = [];

            if (!currentUser || role === 'guest') {
                const snap = await getDocs(
                    query(reportsRef, where('email', '==', 'test@gmail.com'))
                );
                combinedDocs.push(...snap.docs);
            }

            else if (role === 'admin' || userData.role === 'manager' || role === 'inspection' || userData.role === 'coordinator' || role === 'remedial' || role === 'reviewer') {
                const snap = await getDocs(reportsRef);
                combinedDocs.push(...snap.docs);
            }

            else if (role === 'client') {
                const emailSnap = await getDocs(
                    query(reportsRef, where('email', '==', userEmail))
                );
                combinedDocs.push(...emailSnap.docs);
            }

            else if (role === 'inspector') {
                const queries = [
                    getDocs(query(reportsRef, where('assignedInspector', '==', uid))),
                    getDocs(query(reportsRef, where('assignedInspectors', 'array-contains', uid)))
                ];

                const results = await Promise.all(queries);
                const seenIds = new Set();
                results.forEach(result => {
                    result.docs.forEach(doc => {
                        if (!seenIds.has(doc.id)) {
                            seenIds.add(doc.id);
                            combinedDocs.push(doc);
                        }
                    });
                });
            }

            // else if (role === 'reviewer') {
            //     const queries = [
            //         getDocs(query(reportsRef, where('assignedReviewer', '==', uid))),
            //         getDocs(query(reportsRef, where('assignedReviewers', 'array-contains', uid)))
            //     ];

            //     const results = await Promise.all(queries);
            //     const seenIds = new Set();
            //     results.forEach(result => {
            //         result.docs.forEach(doc => {
            //             if (!seenIds.has(doc.id)) {
            //                 seenIds.add(doc.id);
            //                 combinedDocs.push(doc);
            //             }
            //         });
            //     });
            // }

            combinedDocs.sort((a, b) => {
                const dateA = a.data().date?.toMillis?.() ?? 0;
                const dateB = b.data().date?.toMillis?.() ?? 0;
                return dateB - dateA;
            });

            let signOffCount = 0;
            const reportInfos = [];
            const newBuildingGroups = new Map();

            combinedDocs.forEach(doc => {
                const d = doc.data();
                const docId = doc.id;
                reportInfos.push({
                    _docId: docId,
                    buildingLink: d.buildingLink,
                    buildingVideoLink: d.buildingVideoLink,
                    buildingName: d.buildingName,
                    buildingType: d.buildingType,
                    city: d.city,
                    clientAddress: d.clientAddress,
                    clientName: d.clientName,
                    completedBy: d.completedBy,
                    completedByUid: d.completedByUid,
                    date: d.date,
                    dateUpdated: d.dateUpdated,
                    nextDate: d.nextDate,
                    nextDateResidential: d.nextDateResidential,
                    floors: d.floors,
                    personInCharge: d.personInCharge,
                    postcode: d.postcode,
                    reportId: d.reportId,
                    surveryCompleted: d.surveryCompleted,
                    excelLink: d.excelLink,
                    pdfLink: d.pdfLink,
                    pdfResiLink: d.pdfResiLink,
                    uid: d.uid,
                    signOff: d.signOff || false,
                    logo: d.logo,
                    email: d.email,
                    autoSchedule: d.autoSchedule,
                    conciergeDetails: d.conciergeDetails,
                    parkingInfo: d.parkingInfo,
                    accessInfo: d.accessInfo,
                    communalMonths: d.communalMonths,
                });

                if (!d.signOff) signOffCount++;

                if (!newBuildingGroups.has(d.buildingName)) {
                    newBuildingGroups.set(d.buildingName, []);
                }
                newBuildingGroups.get(d.buildingName).push({ docId, date: d.date });
            });

            newBuildingGroups.forEach(group =>
                group.sort((a, b) => new Date(b.date) - new Date(a.date))
            );

            const buildingsWithPrevious = [...newBuildingGroups.entries()]
                .filter(([, g]) => g.length > 1)
                .map(([name]) => name);

            let latestReportsByBuilding = {};
            newBuildingGroups.forEach((group, name) => {
                const latestDocId = group[0].docId;
                const latestReportInfo = reportInfos.find(r => r._docId === latestDocId);
                if (!latestReportInfo) return;
                latestReportsByBuilding[latestDocId] = {
                    reportInfo: latestReportInfo,
                    doorReports: [],
                    resiReports: [],
                };
            });

            if (filterType === 'active') {
                latestReportsByBuilding = Object.fromEntries(
                    Object.entries(latestReportsByBuilding).filter(
                        ([, building]) => building.reportInfo?.surveryCompleted === false
                    )
                );
            }

            buildingGroupsRef.current = newBuildingGroups;
            loadedDoorsRef.current = {};

            setData(latestReportsByBuilding);
            setSignOffCount(signOffCount);
            setReportInfos(reportInfos);
            setBuildingGroups(newBuildingGroups);
            setBuildingsWithPreviousReports(buildingsWithPrevious);
            setLoadedDoors({});

        } catch (error) {
            console.error('Error fetching reports:', error);
        } finally {
            setDataReady(true);
            setLoading(false);
        }
    };

    const loadDoorsForBuilding = async (buildingName) => {

        if (loadedDoorsRef.current[buildingName]) return;

        setDoorsLoading(prev => ({ ...prev, [buildingName]: true }));

        try {
            const group = buildingGroupsRef.current.get(buildingName) || [];
            if (group.length === 0) return;

            const fetches = group.flatMap(({ docId }) => [
                getDocs(collection(db, 'Reports', docId, 'DoorReports'))
                    .then(snap => ({ docId, type: 'door', snap })),
                getDocs(collection(db, 'Reports', docId, 'ResidentialReports'))
                    .then(snap => ({ docId, type: 'resi', snap })),
            ]);
            const results = await Promise.all(fetches);

            const doorsByDocId = {};
            const resiByDocId = {};
            results.forEach(({ docId, type, snap }) => {
                const store = type === 'door' ? doorsByDocId : resiByDocId;
                store[docId] = snap.docs
                    .map(d => d.data())
                    .filter(d => d.addedBy?.trim());
            });

            const mergeByDoorNumber = (allEntries) => {
                let fallbackIndex = 1;
                const latest = {};
                allEntries
                    .sort((a, b) => a.__sourceDate - b.__sourceDate)
                    .forEach(entry => {
                        if (!entry.doorNumber || entry.doorNumber.trim() === '') {
                            entry.doorNumber = `${fallbackIndex++}`;
                        }
                        if (entry.requiresReview !== true) {
                            const k = entry.doorNumber;
                            if (!latest[k] || entry.__sourceDate > latest[k].__sourceDate) {
                                latest[k] = entry;
                            }
                        }
                    });
                return Object.values(latest);
            };

            const allDoors = group.flatMap(({ docId, date }) =>
                (doorsByDocId[docId] || []).map(d => ({ ...d, __sourceDate: new Date(date) }))
            );
            const allResi = group.flatMap(({ docId, date }) =>
                (resiByDocId[docId] || []).map(d => ({ ...d, __sourceDate: new Date(date) }))
            );

            const merged = {
                doorReports: mergeByDoorNumber(allDoors),
                resiReports: mergeByDoorNumber(allResi),
            };

            loadedDoorsRef.current = { ...loadedDoorsRef.current, [buildingName]: merged };
            setLoadedDoors(prev => ({ ...prev, [buildingName]: merged }));

            loadedDoorsRef.current[buildingName] = true;

        } catch (error) {
            console.error('Error loading doors for', buildingName, error);
        } finally {
            setDoorsLoading(prev => ({ ...prev, [buildingName]: false }));
        }
    };

    const doesReportMatchFilter = (reportInfo, filters = {}) => {
        if (!reportInfo) return false;

        const filterLowerCase = (filters.searchText || "").trim().toLowerCase();
        const isFilterDate = /^\d{4}-\d{2}-\d{2}$/.test(filterLowerCase);

        const safeToLowerCase = (value) => String(value ?? "").toLowerCase();

        const matchesText =
            !filterLowerCase ||
            safeToLowerCase(reportInfo.buildingName).includes(filterLowerCase) ||
            safeToLowerCase(reportInfo.buildingType).includes(filterLowerCase) ||
            safeToLowerCase(reportInfo.city).includes(filterLowerCase) ||
            safeToLowerCase(reportInfo.clientAddress).includes(filterLowerCase) ||
            safeToLowerCase(reportInfo.clientName).includes(filterLowerCase) ||
            safeToLowerCase(reportInfo.completedBy).includes(filterLowerCase) ||
            (isFilterDate && (
                safeToLowerCase(reportInfo.date) === filterLowerCase ||
                safeToLowerCase(reportInfo.nextdate) === filterLowerCase
            )) ||
            (!isFilterDate && safeToLowerCase(reportInfo.date).includes(filterLowerCase)) ||
            (!isFilterDate && safeToLowerCase(reportInfo.nextdate).includes(filterLowerCase)) ||
            safeToLowerCase(reportInfo.personInCharge).includes(filterLowerCase) ||
            safeToLowerCase(reportInfo.postcode).includes(filterLowerCase) ||
            safeToLowerCase(reportInfo.reportId).includes(filterLowerCase);

        let matchesFloor = true;
        if (filters.floor) {
            const floorNum = Number(reportInfo.floors || 0);
            let min, max;

            if (filters.floor.includes("+")) {
                min = Number(filters.floor.replace("+", ""));
                max = Infinity;
            } else {
                [min, max] = filters.floor.split("-").map(Number);
            }

            matchesFloor = floorNum >= min && floorNum <= max;
        }

        const matchesClient = filters.clientName
            ? reportInfo.clientName === filters.clientName
            : true;

        const matchesPersonInCharge = filters.personInCharge
            ? reportInfo.personInCharge === filters.personInCharge
            : true;

        return matchesText && matchesFloor && matchesClient && matchesPersonInCharge;
    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear().toString().slice(-2);
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        return `${day}/${month}/${year}`;
    };

    const getNextSurveyDate = (building) => {

        if (building.nextDate) {
            let dateObj = new Date(building.nextDate.replace(' ', 'T'));
            if (isNaN(dateObj.getTime())) {
                dateObj = new Date(building.nextDate);
            }
            if (!isNaN(dateObj.getTime())) {
                const year = dateObj.getFullYear().toString().slice(-2);
                const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
                const day = ("0" + dateObj.getDate()).slice(-2);
                const result = `${day}/${month}/${year}`;
                return result;
            }
        }

        if (!building.date) {
            return "N/A";
        }

        const parsedDate = new Date(building.date.replace(' ', 'T'));

        if (isNaN(parsedDate.getTime())) {
            return "N/A";
        }

        const floorsNum = parseInt(building.floors) || 0;
        const monthsToAdd = floorsNum < 5 ? 12 : 3;

        parsedDate.setMonth(parsedDate.getMonth() + monthsToAdd);

        const year = parsedDate.getFullYear().toString().slice(-2);
        const month = ("0" + (parsedDate.getMonth() + 1)).slice(-2);
        const day = ("0" + parsedDate.getDate()).slice(-2);
        const result = `${day}/${month}/${year}`;

        return result;
    };


    const filteredData = Object.entries(data).filter(([uid, { reportInfo }]) =>
        doesReportMatchFilter(reportInfo, filters)
    );

    const loadDoorsForBatch = async (names) => {

        const toLoad = names.filter(name => !loadedDoorsRef.current[name]);
        if (toLoad.length === 0) return;

        await Promise.all(toLoad.map(name => loadDoorsForBuilding(name)));
    };

    useEffect(() => {
        if (loadingAuth) return;
        if (!userData.ready) {
            return;
        }

        setDataReady(false);
        isFirstFilterRun.current = true;

        const run = async () => {
            setLoading(true);
            try {
                await fetchInspectores();
                await fetchDoorReports();
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        run();
        if (!restoreRef.current) window.scrollTo(0, 0);
    }, [userData.ready, userData.role]);

    const sortedFilteredData = Object.entries(data)
        .filter(([, { reportInfo }]) => reportInfo?.buildingName && doesReportMatchFilter(reportInfo, filters))
        .sort(([, a], [, b]) => {
            const nameA = a.reportInfo?.buildingName || '';
            const nameB = b.reportInfo?.buildingName || '';
            return nameA.localeCompare(nameB);
        });

    const visibleData = sortedFilteredData.slice(0, visibleCount);
    const hasMore = sortedFilteredData.length > visibleCount;

    useEffect(() => {
        sessionStorage.removeItem(RESTORE_KEY);
    }, []);

    useEffect(() => {
        if (!dataReady || !buildingGroups.size) return;
        const names = sortedFilteredData
            .slice(0, visibleCount)
            .map(([, { reportInfo }]) => reportInfo.buildingName);
        let cancelled = false;
        (async () => {
            for (let i = 0; i < names.length; i += 20) {
                if (cancelled) return;
                await loadDoorsForBatch(names.slice(i, i + 20));
            }
        })();
        return () => { cancelled = true; };
    }, [dataReady, buildingGroups]);

    useEffect(() => {
        if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
        return () => {
            if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
        };
    }, []);

    useEffect(() => {
        const events = ['wheel', 'touchmove', 'keydown', 'mousedown'];
        const onUser = () => { if (restoreRef.current) disarmRestore(); };
        events.forEach(e => window.addEventListener(e, onUser, { passive: true }));
        return () => events.forEach(e => window.removeEventListener(e, onUser));
    }, []);

    useEffect(() => {
        const r = restoreRef.current;
        if (!r || !dataReady || visibleData.length === 0) return;

        if (r.top == null) {
            disarmRestore();
            return;
        }

        let ticks = 0;
        let stable = 0;

        const timer = setInterval(() => {
            if (!restoreRef.current) { clearInterval(timer); return; }
            ticks++;

            const el = document.getElementById(`building-${r.uid}`);
            if (el && el.getClientRects().length) {
                const delta = el.getBoundingClientRect().top - r.top;
                if (Math.abs(delta) > 2) {
                    scrollerFor(el, r.hops).scrollBy({ top: delta, behavior: 'instant' });
                    stable = 0;
                } else {
                    stable++;
                }
            }

            if (stable >= 30) {
                clearInterval(timer);
            } else if (ticks > 200) {
                clearInterval(timer);
                disarmRestore();
            }
        }, 100);

        return () => clearInterval(timer);
    }, [dataReady, visibleData.length]);

    const handleLoadMore = async () => {
        setLoadingMore(true);
        try {
            const allSortedNames = sortedFilteredData.map(([, { reportInfo }]) => reportInfo.buildingName);
            const nextBatch = allSortedNames.slice(visibleCount, visibleCount + 20);
            await loadDoorsForBatch(nextBatch);
            setVisibleCount(prev => prev + 20);
        } finally {
            setLoadingMore(false);
        }
    };

    const handleSearchInput = (value) => {
        if (value.trim().length < 2) { setSearchSuggestions([]); return; }
        const lower = value.toLowerCase();
        const matches = [...buildingGroupsRef.current.keys()]
            .filter(name => name && typeof name === 'string')
            .filter(name => name.toLowerCase().includes(lower))
            .sort((a, b) => a.localeCompare(b))
            .slice(0, 8);
        setSearchSuggestions(matches);
    };

    const handleSuggestionClick = async (name) => {
        handleFilterClick("searchText", name);
        setSearchSuggestions([]);

        const allSortedNames = [...buildingGroupsRef.current.keys()]
            .filter(n => n && typeof n === 'string')
            .sort((a, b) => a.localeCompare(b));
        const idx = allSortedNames.indexOf(name);
        if (idx !== -1) {
            setVisibleCount(prev => Math.max(prev, idx + 1));
        }

        await loadDoorsForBuilding(name);
    };

    useEffect(() => {
        if (!dataReady) return;
        if (Object.keys(loadedDoors).length === 0) return;
        fetchLocations1();
    }, [loadedDoors, dataReady]);

    const calculateBuildingCounts = (doorReports, resiReports) => {
        let totalTrueCount = 0;
        let totalFalseCount = 0;
        let totalReqAttentionCount = 0;
        let totalHasAccessCount = 0;

        const combinedReports = [...doorReports, ...resiReports];

        combinedReports.forEach(door => {
            let trueCount = 0;
            let falseCount = 0;
            let reqAttentionCount = 0;
            let hasAccessCount = 0;

            const d1 = parseFloat(door.fD1) || 0;
            const d2 = parseFloat(door.fD2) || 0;
            const d3 = parseFloat(door.fD3) || 0;
            const d4 = parseFloat(door.fD4) || 0;

            const condition1 = (d1 <= 4 && d2 <= 4 && d3 <= 4);
            const condition2 = (d4 <= 8);

            if (door.doorCloseAsIntented === false) {
                falseCount++;
            } else {
                trueCount++;
            }

            if (door.hasOwnProperty('doorStrips')) {
                const doorStrips = door.doorStrips;
                if (doorStrips) {
                    trueCount++;
                } else {
                    falseCount++;
                }
            }

            if (door.hingesWorking) trueCount++; else falseCount++;
            if (door.hingesFireRating) trueCount++; else falseCount++;

            const damageMultiples = (door.damageMultiples || []).map(item => item.toString());
            if (damageMultiples.includes('None') && damageMultiples.length === 1) {
                trueCount++;
            } else {
                const isValidCondition = (damageMultiples.includes('Door Pass') || !damageMultiples.includes('Door')) &&
                    (damageMultiples.includes('Frame Pass') || !damageMultiples.includes('Frame')) &&
                    (damageMultiples.includes('Glass None') || damageMultiples.includes('Glass Pass') || !damageMultiples.includes('Glass')) &&
                    (damageMultiples.includes('Ventilation Gaps None') || damageMultiples.includes('Ventilation Gaps Pass') || !damageMultiples.includes('Ventilation Gaps'));

                if (isValidCondition) {
                    trueCount++;
                } else {
                    falseCount++;
                }
            }

            const doorCertif = door.doorCertif || '';
            if (doorCertif && !doorCertif.includes('No')) {
                trueCount++;
            } else {
                falseCount++;
            }

            if (condition1 && condition2) {
                trueCount++;
            } else {
                falseCount++;
            }

            if (door.requiresAttention) reqAttentionCount++;
            if (door.hasAccess === false) hasAccessCount++;

            if (reqAttentionCount == 0 && hasAccessCount == 0) {
                if (falseCount >= 1) {
                    totalFalseCount++;
                } else if (falseCount == 0) {
                    totalTrueCount++;
                }
            }

            if (reqAttentionCount >= 1) {
                totalReqAttentionCount += 1;
            }
            if (hasAccessCount >= 1) {
                totalHasAccessCount += 1;
            }
        });


        return { totalTrueCount, totalFalseCount, totalReqAttentionCount, totalHasAccessCount };
    };

    const fetchLocations1 = async () => {
        if (!data) return;

        const locPromises = Object.entries(data).map(async ([docId, report]) => {
            const postcode = report.reportInfo?.postcode;
            const buildingName = report.reportInfo?.buildingName;

            if (!postcode) return null;

            const coords = await getCoordinatesPostcodeIO(postcode);
            if (!coords) return null;

            const loaded = loadedDoorsRef.current[buildingName];
            const doorReports = loaded?.doorReports || [];
            const resiReports = loaded?.resiReports || [];

            const counts = calculateBuildingCounts(doorReports, resiReports);

            return {
                id: report.reportInfo.uid,
                name: buildingName,
                buildingLink: report.reportInfo.buildingLink,
                clientName: report.reportInfo.clientName,
                city: report.reportInfo.city,
                lat: coords.lat,
                lng: coords.lng,
                ...counts
            };
        });

        const results = await Promise.allSettled(locPromises);
        const locs = results.filter(r => r.status === "fulfilled" && r.value).map(r => r.value);
        setLocations(locs);
    };

    useEffect(() => {
        const fetchInspectorInfos = async () => {
            try {
                const usersCollectionRef = collection(db, `users/${user.uid}/acc_manager`);
                const q = query(
                    usersCollectionRef
                );
                const querySnapshot = await getDocs(q);

                const fetchedInspectorInfos = [];

                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    fetchedInspectorInfos.push({
                        uid: doc.id,
                        name: data.name || 'Unknown Name',
                        email: data.email || 'No Email',
                    });
                });

                // console.log("Fetched Inspectors:", fetchedInspectorInfos);
                setInspectorInfos(fetchedInspectorInfos);
            } catch (err) {
                console.error('Error fetching inspectors:', err);
                setError('Failed to fetch inspectors.');
            }
        };
        if (user) {
            fetchInspectorInfos();
        }
    }, [db]);


    const handleNavigate = (buildingName) => {
        navigate('/pdf_archives', {
            state: { archives: reportInfos, buildingName: buildingName },
        });
    };

    const messages = [
        "Fetching your reports...",
        "Compiling results...",
        "Almost there..."
    ];

    const [messageIndex, setMessageIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [displayedText, setDisplayedText] = useState('');

    useEffect(() => {
        sessionStorage.setItem("filters", JSON.stringify(filters));
    }, [filters]);

    useEffect(() => {
        const currentMessage = messages[messageIndex];

        if (charIndex < currentMessage.length) {
            const timeout = setTimeout(() => {
                setDisplayedText(currentMessage.slice(0, charIndex + 1));
                setCharIndex((prev) => prev + 1);
            }, 30);
            return () => clearTimeout(timeout);
        } else if (messageIndex < messages.length - 1) {
            const delay = setTimeout(() => {
                setMessageIndex((prev) => prev + 1);
                setCharIndex(0);
                setDisplayedText('');
            }, 1500);
            return () => clearTimeout(delay);
        }
    }, [charIndex, messageIndex, messages]);

    const hasList = Object.keys(data || {}).length > 0;

    if (loading && !hasList) {
        return (
            <div className="loading-container">
                <ClipLoader color="#b11111" size={60} />
                <div className="loading-text">
                    {displayedText}
                    <span className="cursor">|</span>
                </div>
            </div>
        );
    }

    const handleReportClick = (uid, buildingData, totalTrueCount, totalFalseCount, metricType = null) => {
        if (!uid) return;
        saveListState(uid);

        if (metricType) {
            const metricMap = {
                pass: 'Passed',
                fail: 'Failed',
                reinspection: 'Attention',
                no_access: 'NoAccess'
            };
            const value = metricMap[metricType];
            if (value) {
                sessionStorage.setItem(`filter_${uid}`, value);
                sessionStorage.setItem(`resi_filter_${uid}`, value);
            }
        }
        else {
            sessionStorage.removeItem(`filter_${uid}`);
            sessionStorage.removeItem(`resi_filter_${uid}`);
        }

        navigate(`/doors/${uid}`, {
            state: { buildingData, totalTrueCount, totalFalseCount }
        });
    };

    const handleEscalationStrategy = (reportInfo) => {
        saveListState(reportInfo.uid);
        navigate(`/escalate/${reportInfo.uid}`, {
            state: {
                reportInfo,
            },
        });
    };


    const getImageSrc = (link) => {
        if (link) {
            if (link.startsWith('/9j/')) {
                return `data:image/jpeg;base64,${link}`;
            } else if (link.startsWith('http')) {
                return link;
            }
        }
        return defaultImage;
    };

    const handleFilterClick = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
        setVisibleCount(20);
    };

    const dataArray = data ? Object.values(data) : [];

    const clean = v => (typeof v === "string" ? v.trim() : v);

    // const floorsOptions = [...new Set(
    //     dataArray
    //         .map(b => clean(b.reportInfo?.floors))
    //         .filter(v => v !== undefined && v !== null && v !== "")
    // )]
    //     .sort((a, b) => Number(a) - Number(b))
    //     .map(f => ({ value: f, label: f }));

    const floorRanges = ["1-3", "4-6", "6+"];

    const floorsOptions = floorRanges
        .filter(r => {
            const [min, max] = r.includes("+")
                ? [Number(r.replace("+", "")), Infinity]
                : r.split("-").map(Number);

            return dataArray.some(b => {
                const floor = Number(b.reportInfo?.floors);
                return floor >= min && floor <= max;
            });
        })
        .map(r => ({ value: r, label: r }));

    const clientsOptions = [...new Set(
        dataArray
            .map(b => clean(b.reportInfo?.clientName))
            .filter(v => v !== undefined && v !== null && v !== "")
    )]
        .sort((a, b) => a.localeCompare(b))
        .map(c => ({ value: c, label: c }));

    const personInChargeOptions = [...new Set(
        dataArray
            .map(b => clean(b.reportInfo?.personInCharge))
            .filter(v => v !== undefined && v !== null && v !== "")
    )]
        .sort((a, b) => a.localeCompare(b))
        .map(p => ({ value: p, label: p }));


    const selectStyles = {
        control: (provided, { isFocused }) => ({
            ...provided,
            borderRadius: "0.375rem",
            padding: "0 0.5rem",
            borderColor: isFocused ? "#dc3545" : "#ced4da",
            boxShadow: isFocused ? "0 0 0 0.2rem rgba(220,53,69,.25)" : "none",
            minHeight: "48px",
            height: "48px",
            outline: "none",
            "&:hover": { borderColor: "#dc3545" },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: 'pointer',
        }),
        menu: (provided) => ({
            ...provided,
            width: "260px",
        }),
        option: (provided, { isFocused, isSelected }) => ({
            ...provided,
            backgroundColor: isSelected
                ? "#dc3545"
                : isFocused
                    ? "#ffe5e5"
                    : "white",
            color: isSelected ? "white" : "#333",
            cursor: "pointer",
            minHeight: "38px",
            display: "flex",
            alignItems: "center",
            "&:active": { backgroundColor: "#dc3545" },
        }),
        singleValue: provided => ({
            ...provided,
            color: "#282828ff",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
        placeholder: provided => ({
            ...provided,
            color: "#282828ff",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
        dropdownIndicator: provided => ({
            ...provided,
            color: "#a71d2a",
            "&:hover": { color: "#dc3545" },
        }),
        clearIndicator: provided => ({
            ...provided,
            color: "#a71d2a",
            "&:hover": { color: "#dc3545" },
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }),
    };

    const buildingTypeOptions = [
        { value: "Assembly and Recreation", label: "Assembly and Recreation" },
        { value: "Health Care", label: "Health Care" },
        { value: "Industrial", label: "Industrial" },
        { value: "Mixed Use", label: "Mixed Use" },
        { value: "Office", label: "Office" },
        { value: "Residential", label: "Residential" },
        { value: "Shop/Commercial", label: "Shop/Commercial" },
        { value: "Storage", label: "Storage" },
        { value: "Other", label: "Other" },
    ];



    return (
        <div className="container-fluid service__section">
            {loading && hasList && (
                <div style={{
                    position: 'fixed', inset: 0, zIndex: 3000,
                    background: 'rgba(255,255,255,0.55)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <ClipLoader color="#b11111" size={50} />
                </div>
            )}
            <div className="services__great__wrapper" style={{ paddingTop: '0px' }} id="services">
                <div className="container" style={{ marginBottom: '-50vh' }}>
                    <div className="row justify-content-center gy-5" style={{ marginTop: '10px' }}>

                        <div className="container-fluid py-4">
                            <div className="row g-3">

                                <div className="col-12 col-lg-4 order-0 order-lg-0">
                                    <div className="row g-3">

                                        <div className="col-6 col-sm-6 col-lg-6">
                                            <Select
                                                options={floorsOptions}
                                                value={filters.floor ? { value: filters.floor, label: filters.floor } : null}
                                                onChange={(selected) => handleFilterClick("floor", selected ? selected.value : "")}
                                                placeholder="Floors"
                                                isClearable
                                                menuPortalTarget={document.body}
                                                styles={selectStyles}
                                                aria-label="Filter by floor"
                                            />
                                        </div>

                                        <div className="col-6 col-sm-6 col-lg-6">
                                            {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'coordinator' || userData.role === 'remedial' || userData.role === 'reviewer') ? (
                                                <Select
                                                    options={clientsOptions}
                                                    value={filters.clientName ? { value: filters.clientName, label: filters.clientName } : null}
                                                    onChange={(selected) => handleFilterClick("clientName", selected ? selected.value : "")}
                                                    placeholder="Client"
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                    styles={selectStyles}
                                                    aria-label="Filter by client"
                                                />
                                            ) : (
                                                <Select
                                                    options={personInChargeOptions}
                                                    value={filters.personInCharge ? { value: filters.personInCharge, label: filters.personInCharge } : null}
                                                    onChange={(selected) => handleFilterClick("personInCharge", selected ? selected.value : "")}
                                                    placeholder="Property Manager"
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                    styles={selectStyles}
                                                    aria-label="Filter by property manager"
                                                />
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div className="col-12 col-lg-4 order-2 order-lg-1">
                                    <div style={{ position: 'relative' }}>
                                        <div className="input-group shadow-sm h-100">
                                            <input
                                                type="text"
                                                className="form-control border-danger"
                                                placeholder="Search building, type, report, city..."
                                                value={filters.searchText || ''}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    handleFilterClick("searchText", val);
                                                    if (!val.trim()) {
                                                        setSearchSuggestions([]);
                                                        return;
                                                    }
                                                    handleSearchInput(val);
                                                }}
                                                onBlur={() => setTimeout(() => setSearchSuggestions([]), 150)}
                                                style={{ height: '48px', fontSize: '0.95rem', borderRight: 'none', paddingRight: filters.searchText ? '32px' : '12px' }}
                                                aria-label="Search filter"
                                            />

                                            {filters.searchText && (
                                                <span
                                                    onClick={() => {
                                                        handleFilterClick("searchText", "");
                                                        setSearchSuggestions([]);
                                                        setVisibleCount(20);
                                                    }}
                                                    style={{
                                                        position: 'absolute',
                                                        right: '52px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        zIndex: 10,
                                                        cursor: 'pointer',
                                                        color: '#6c757d',
                                                        fontSize: '16px',
                                                        lineHeight: 1,
                                                        padding: '4px',
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faTimes} />
                                                </span>
                                            )}

                                            <span
                                                className="input-group-text bg-danger text-white border-danger"
                                                style={{ cursor: 'pointer', height: '48px' }}
                                                role="button"
                                                tabIndex="0"
                                                aria-label="Search"
                                            >
                                                <FontAwesomeIcon icon={faSearch} />
                                            </span>
                                        </div>


                                        {searchSuggestions.length > 0 && (
                                            <div style={{
                                                position: 'absolute', top: '100%', left: 0, right: 0,
                                                zIndex: 9999,
                                                background: '#ffffff',
                                                border: '1px solid #dee2e6',
                                                borderRadius: '8px', marginTop: '4px',
                                                boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                                                overflow: 'hidden',
                                            }}>
                                                {searchSuggestions.map((name, i) => (
                                                    <div
                                                        key={name}
                                                        onMouseDown={() => handleSuggestionClick(name)}
                                                        style={{
                                                            padding: '10px 14px',
                                                            cursor: 'pointer',
                                                            fontSize: '13px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            borderBottom: i < searchSuggestions.length - 1
                                                                ? '1px solid #f0f0f0'
                                                                : 'none',
                                                            background: '#ffffff',
                                                            transition: 'background 0.15s',
                                                            color: '#212529',
                                                        }}
                                                        onMouseEnter={e => e.currentTarget.style.background = '#fff5f5'}
                                                        onMouseLeave={e => e.currentTarget.style.background = '#ffffff'}
                                                    >
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <FontAwesomeIcon
                                                                icon={faBuilding}
                                                                style={{ fontSize: '11px', color: '#adb5bd' }}
                                                            />
                                                            <span style={{ color: '#212529' }}>{name}</span>
                                                        </div>
                                                        {loadedDoorsRef.current[name] ? (
                                                            <span style={{ fontSize: '11px', color: '#10b981', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                                                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" />
                                                                    <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                                ready
                                                            </span>
                                                        ) : doorsLoading[name] ? (
                                                            <span style={{ fontSize: '11px', color: '#f59e0b', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                <span className="spinner-border spinner-border-sm" style={{ width: '10px', height: '10px', borderWidth: '1.5px' }} />
                                                                loading…
                                                            </span>
                                                        ) : (
                                                            <span style={{ fontSize: '11px', color: '#adb5bd', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M12 4v16m8-8H4" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                                                                </svg>
                                                                tap to load
                                                            </span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 col-lg-4 order-1 order-lg-2">
                                    <div className="row g-3">

                                        <div className="col-6 col-sm-6 col-lg-6">
                                            <button
                                                className="btn btn-light border shadow-sm d-flex align-items-center justify-content-center w-100"
                                                style={{
                                                    height: '48px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onClick={goToCalendar}
                                                aria-label="Go to calendar"
                                            >
                                                <FontAwesomeIcon icon={faCalendarAlt} className="text-secondary me-2" />
                                                <span className="fw-semibold">Calendar</span>
                                            </button>
                                        </div>

                                        <div className="col-6 col-sm-6 col-lg-6">
                                            <button
                                                className="btn btn-light border shadow-sm d-flex align-items-center justify-content-center w-100"
                                                style={{
                                                    height: '48px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onClick={() => setShowMapModal(true)}
                                                aria-label="Open map view"
                                            >
                                                <FontAwesomeIcon icon={faMapLocationDot} className="text-success me-2" />
                                                <span className="fw-semibold">Map View</span>
                                            </button>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>


                        {/* <div className="row mb-4 align-items-center" style={{ paddingTop: '0px' }}>
                            <div className="col-2"></div>

                            <div className="col-8 d-flex justify-content-center">
                                <div className="input-group" style={{ maxWidth: '700px', width: '100%' }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Filter by Building Name, Type, Report Name, City"
                                        value={filter}
                                        onChange={handleFilterChange}
                                        style={{
                                            padding: '9px 14px',
                                            borderRadius: '5px',
                                            border: '1px solid #ff0000',
                                            fontSize: '0.95rem',
                                            boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
                                            transition: 'box-shadow 0.3s ease',
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.boxShadow = '0 0 8px rgba(255, 0, 0, 0.6)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.boxShadow = 'inset 0 1px 1px rgba(0, 0, 0, 0.075)';
                                        }}
                                    />
                                    <span
                                        className="input-group-text"
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: 'red',
                                            color: 'white',
                                            padding: '9px 12px',
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faSearch} />
                                    </span>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className="col-2 d-flex justify-content-end align-items-center">
                            <button
                                className="btn btn-outline-danger d-flex align-items-center"
                                onClick={() => setShowCompare(true)}
                                style={{
                                    borderRadius: '5px',
                                    padding: '9px',
                                    fontSize: '0.95rem',
                                }}
                            >
                                <FontAwesomeIcon icon={faBuilding} className="me-2" />
                                Compare Buildings
                                <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                            </button>
                        </div> */}

                        <div style={{ textAlign: 'center', margin: '10px 0' }}>
                            <h3 className="text-capitalize d-inline-block">{filterType} Reports</h3>
                        </div>

                        <div className="d-block d-md-none" style={{ marginTop: '0px' }}>
                            {visibleData.length > 0 && (
                                <Swiper
                                    initialSlide={initialSlideRef.current}
                                    spaceBetween={20}
                                    slidesPerView={1}
                                    navigation={true}
                                    pagination={{
                                        clickable: true,
                                        dynamicBullets: true,
                                    }}
                                    modules={[Pagination]}
                                    onSlideChange={handleSlideChange}
                                    style={{ width: '100%', paddingBottom: '40px' }}
                                >

                                    {visibleData
                                        .filter(([, { reportInfo }]) => reportInfo?.buildingName)
                                        .sort(([, a], [, b]) => {
                                            const nameA = a.reportInfo?.buildingName || '';
                                            const nameB = b.reportInfo?.buildingName || '';
                                            return nameA.localeCompare(nameB);
                                        })
                                        .map(([uid, { reportInfo }]) => {
                                            const buildingName = reportInfo.buildingName;
                                            const doorsData = loadedDoors[buildingName];
                                            const isLoadingDoors = doorsLoading[buildingName];
                                            const hasLoaded = !!doorsData;

                                            let totalTrueCount = 0;
                                            let totalFalseCount = 0;
                                            let totalReqAttentionCount = 0;
                                            let totalHasAccessCount = 0;

                                            if (hasLoaded) {
                                                const combinedReports = [
                                                    ...(doorsData.doorReports || []),
                                                    ...(doorsData.resiReports || []),
                                                ];
                                                combinedReports.forEach(door => {
                                                    let trueCount = 0;
                                                    let falseCount = 0;
                                                    let reqAttentionCount = 0;
                                                    let hasAccessCount = 0;

                                                    const d1 = parseFloat(door.fD1) || 0;
                                                    const d2 = parseFloat(door.fD2) || 0;
                                                    const d3 = parseFloat(door.fD3) || 0;
                                                    const d4 = parseFloat(door.fD4) || 0;
                                                    const condition1 = (d1 <= 4 && d2 <= 4 && d3 <= 4);
                                                    const condition2 = (d4 <= 8);

                                                    if (door.doorCloseAsIntented === false) falseCount++; else trueCount++;

                                                    if (door.hasOwnProperty('doorStrips')) {
                                                        door.doorStrips ? trueCount++ : falseCount++;
                                                    }

                                                    if (door.hingesWorking) trueCount++; else falseCount++;
                                                    if (door.hingesFireRating) trueCount++; else falseCount++;

                                                    const damageMultiples = (door.damageMultiples || []).map(item => item.toString());
                                                    if (damageMultiples.includes('None') && damageMultiples.length === 1) {
                                                        trueCount++;
                                                    } else {
                                                        const isValidCondition =
                                                            (damageMultiples.includes('Door Pass') || !damageMultiples.includes('Door')) &&
                                                            (damageMultiples.includes('Frame Pass') || !damageMultiples.includes('Frame')) &&
                                                            (damageMultiples.includes('Glass None') || damageMultiples.includes('Glass Pass') || !damageMultiples.includes('Glass')) &&
                                                            (damageMultiples.includes('Ventilation Gaps None') || damageMultiples.includes('Ventilation Gaps Pass') || !damageMultiples.includes('Ventilation Gaps'));
                                                        isValidCondition ? trueCount++ : falseCount++;
                                                    }

                                                    const doorCertif = door.doorCertif || '';
                                                    doorCertif && !doorCertif.includes('No') ? trueCount++ : falseCount++;
                                                    condition1 && condition2 ? trueCount++ : falseCount++;

                                                    if (door.requiresAttention) reqAttentionCount++;
                                                    if (door.hasAccess === false) hasAccessCount++;

                                                    if (reqAttentionCount === 0 && hasAccessCount === 0) {
                                                        falseCount >= 1 ? totalFalseCount++ : totalTrueCount++;
                                                    }
                                                    if (reqAttentionCount >= 1) totalReqAttentionCount++;
                                                    if (hasAccessCount >= 1) totalHasAccessCount++;
                                                });
                                            }

                                            const formattedNextDate = formatDate(reportInfo.nextDate);
                                            const totalDoors = totalTrueCount + totalFalseCount + totalReqAttentionCount;

                                            return (
                                                <SwiperSlide key={uid}>
                                                    <div className={`building-card premium-design ${!hasLoaded ? '' :
                                                        totalFalseCount === 0 ? 'status-compliant' : 'status-critical'
                                                        }`}>

                                                        <div className="card-header-wrapper">
                                                            <div className="media-container">
                                                                {reportInfo.buildingVideoLink ? (
                                                                    <video autoPlay muted loop playsInline
                                                                        onClick={() => hasLoaded && handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount)}
                                                                        className="premium-media"
                                                                    >
                                                                        <source src={reportInfo.buildingVideoLink} type="video/mp4" />
                                                                    </video>
                                                                ) : (
                                                                    <img
                                                                        src={getImageSrc(reportInfo.buildingLink)}
                                                                        alt={buildingName}
                                                                        className="premium-media"
                                                                        onClick={() => hasLoaded && handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount)}
                                                                    />
                                                                )}
                                                                <div className="media-gradient-overlay" />
                                                                <div className="media-shine-effect" />
                                                            </div>

                                                            <div className="card-top-bar">
                                                                <div className={`status-pill ${isLoadingDoors ? 'pill-neutral' :
                                                                    !hasLoaded ? 'pill-neutral' :
                                                                        totalFalseCount === 0 ? 'pill-success' : 'pill-error'
                                                                    }`}>
                                                                    <div className="status-dot" />
                                                                    <span className="status-text">
                                                                        {isLoadingDoors
                                                                            ? <><span className="spinner-border spinner-border-sm me-1" style={{ width: '10px', height: '10px' }} /> Loading…</>
                                                                            : !hasLoaded ? '—'
                                                                                : totalFalseCount === 0 ? 'Fully Compliant'
                                                                                    : `${totalFalseCount} Critical Issue${totalFalseCount !== 1 ? 's' : ''}`
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="card-content-premium">
                                                            <div className="building-header">
                                                                <div className="building-info">
                                                                    <h3 className="building-title" title={buildingName}>{buildingName}</h3>
                                                                </div>
                                                            </div>

                                                            {!hasLoaded && (
                                                                <div style={{ opacity: 0.4 }}>
                                                                    <div className="progress-section">
                                                                        <div className="progress-header">
                                                                            <span className="progress-title">Compliance Progress</span>
                                                                            <span className="progress-stats">— / —</span>
                                                                        </div>
                                                                        <div className="progress-track">
                                                                            <div className="progress-fill" style={{ width: '0%' }} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="metrics-grid">
                                                                        <div className="metric-card success">
                                                                            <div className="metric-top">
                                                                                <div className="metric-icon">
                                                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                                        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" />
                                                                                        <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                                    </svg>
                                                                                </div>
                                                                                <span className="metric-value">—</span>
                                                                            </div>
                                                                            <span className="metric-label">Pass</span>
                                                                        </div>
                                                                        <div className="metric-card critical">
                                                                            <div className="metric-top">
                                                                                <div className="metric-icon">
                                                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                                        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" />
                                                                                        <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
                                                                                        <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
                                                                                    </svg>
                                                                                </div>
                                                                                <span className="metric-value">—</span>
                                                                            </div>
                                                                            <span className="metric-label">Fail</span>
                                                                        </div>
                                                                        <div className="metric-card warning">
                                                                            <div className="metric-top">
                                                                                <div className="metric-icon">
                                                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                                        <path d="M21 12a9 9 0 11-3.51-7.09L21 8M21 8V3m0 5h-5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                                    </svg>
                                                                                </div>
                                                                                <span className="metric-value">—</span>
                                                                            </div>
                                                                            <span className="metric-label">Re-Inspection</span>
                                                                        </div>
                                                                        <div className="metric-card neutral">
                                                                            <div className="metric-top">
                                                                                <div className="metric-icon">
                                                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                                        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" />
                                                                                        <line x1="5.636" y1="5.636" x2="18.364" y2="18.364" stroke="currentColor" strokeWidth="1" />
                                                                                    </svg>
                                                                                </div>
                                                                                <span className="metric-value">—</span>
                                                                            </div>
                                                                            <span className="metric-label">No Access</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {hasLoaded && (
                                                                <>
                                                                    <div className="progress-section">
                                                                        <div className="progress-header">
                                                                            <span className="progress-title">Compliance Progress</span>
                                                                            <span className="progress-stats">{totalTrueCount}/{totalDoors} items</span>
                                                                        </div>
                                                                        <div className="progress-track">
                                                                            <div
                                                                                className="progress-fill"
                                                                                style={{
                                                                                    width: `${totalDoors > 0 ? (totalTrueCount / totalDoors) * 100 : 0}%`,
                                                                                    background: totalFalseCount === 0
                                                                                        ? 'linear-gradient(90deg, #10b981, #22c55e)'
                                                                                        : totalFalseCount > 5
                                                                                            ? 'linear-gradient(90deg, #ef4444, #dc2626)'
                                                                                            : 'linear-gradient(90deg, #f59e0b, #eab308)',
                                                                                }}
                                                                            >
                                                                                <div className="progress-glow" />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="metrics-grid">
                                                                        <div className="metric-card success" onClick={() => handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount, 'pass')}>
                                                                            <div className="metric-top">
                                                                                <div className="metric-icon">
                                                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                                        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" />
                                                                                        <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                                    </svg>
                                                                                </div>
                                                                                <span className="metric-value">{totalTrueCount}</span>
                                                                            </div>
                                                                            <span className="metric-label">Pass</span>
                                                                        </div>

                                                                        <div className="metric-card critical" onClick={() => handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount, 'fail')}>
                                                                            <div className="metric-top">
                                                                                <div className="metric-icon">
                                                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                                        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" />
                                                                                        <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
                                                                                        <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
                                                                                    </svg>
                                                                                </div>
                                                                                <span className="metric-value">{totalFalseCount}</span>
                                                                            </div>
                                                                            <span className="metric-label">Fail</span>
                                                                        </div>

                                                                        <div className="metric-card warning" onClick={() => handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount, 'reinspection')}>
                                                                            <div className="metric-top">
                                                                                <div className="metric-icon">
                                                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                                        <path d="M21 12a9 9 0 11-3.51-7.09L21 8M21 8V3m0 5h-5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                                    </svg>
                                                                                </div>
                                                                                <span className="metric-value">{totalReqAttentionCount}</span>
                                                                            </div>
                                                                            <span className="metric-label">Re-Inspection</span>
                                                                        </div>

                                                                        <div className="metric-card neutral" onClick={() => handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount, 'no_access')}>
                                                                            <div className="metric-top">
                                                                                <div className="metric-icon">
                                                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                                        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" />
                                                                                        <line x1="5.636" y1="5.636" x2="18.364" y2="18.364" stroke="currentColor" strokeWidth="1" />
                                                                                    </svg>
                                                                                </div>
                                                                                <span className="metric-value">{totalHasAccessCount}</span>
                                                                            </div>
                                                                            <span className="metric-label">No Access</span>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}

                                                            <div className="card-footer-premium">
                                                                {/* <div className="footer-content">
                                                                    <div className="date-info text-center mb-2">
                                                                        <div className="date-badge d-inline-flex align-items-center">
                                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="calendar-icon me-1">
                                                                                <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                                                    stroke="currentColor" strokeWidth="1" />
                                                                            </svg>
                                                                            <span className="date-value">Next Survey: {getNextSurveyDate(reportInfo)}</span>
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                                <button
                                                                    className="premium-action-btn w-100 mt-3"
                                                                    disabled={!hasLoaded}
                                                                    onClick={() => hasLoaded && handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount)}
                                                                >
                                                                    <span>View Full Report</span>
                                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                                        <path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                </Swiper>
                            )}
                        </div>

                        <div className="container d-none d-md-block" style={{ paddingTop: '0px' }}>
                            <div className="row justify-content-center">
                                {/* {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'coordinator' || userData.role === 'remedial') && (
                                    <div className="col-lg-3 col-md-6 col-12 mb-4">
                                        <div
                                            className="card rounded-lg d-flex justify-content-center align-items-center"
                                            style={{
                                                height: '650px',
                                                maxHeight: '650px',
                                                border: "3px dashed #ccc",
                                                borderRadius: '2rem',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                backgroundColor: isHovered ? '#ffe6e6' : 'transparent',
                                                transition: 'background-color 0.3s',
                                            }}
                                            onMouseEnter={() => setIsHovered(true)}
                                            onMouseLeave={() => setIsHovered(false)}
                                            onClick={() => {
                                                // console.log("Card clicked");
                                                setShowDetailsModal(true);
                                            }}
                                        >
                                            <div style={{
                                                fontWeight: 'bold',
                                                fontSize: '2.0rem',
                                                color: 'black',
                                                marginBottom: '10px'
                                            }}>
                                                New Building
                                            </div>
                                            <FontAwesomeIcon
                                                icon={faPlus}
                                                size="10x"
                                                style={{
                                                    color: isHovered ? '#b30000' : 'red',
                                                    transition: 'color 0.3s',
                                                }}
                                            />
                                        </div>
                                    </div>
                                )} */}


                                {/* {filteredData.map(([uid, { reportInfo, doorReports, resiReports }]) => { */}
                                {visibleData
                                    .sort(([, a], [, b]) => a.reportInfo.buildingName.localeCompare(b.reportInfo.buildingName))
                                    .map(([uid, { reportInfo }]) => {

                                        const buildingName = reportInfo.buildingName;
                                        const doorsData = loadedDoors[buildingName];
                                        const isLoadingDoors = doorsLoading[buildingName];
                                        const hasLoaded = !!doorsData;

                                        let totalTrueCount = 0;
                                        let totalFalseCount = 0;
                                        let totalReqAttentionCount = 0;
                                        let totalHasAccessCount = 0;

                                        if (hasLoaded) {
                                            const combinedReports = [...doorsData.doorReports, ...doorsData.resiReports];

                                            combinedReports.forEach(door => {

                                                const d1 = parseFloat(door.fD1) || 0;
                                                const d2 = parseFloat(door.fD2) || 0;
                                                const d3 = parseFloat(door.fD3) || 0;
                                                const d4 = parseFloat(door.fD4) || 0;
                                                const condition1 = (d1 <= 4 && d2 <= 4 && d3 <= 4);
                                                const condition2 = (d4 <= 8);

                                                let trueCount = 0;
                                                let falseCount = 0;
                                                let reqAttentionCount = 0;
                                                let hasAccessCount = 0;

                                                if (door.doorCloseAsIntented === false) falseCount++; else trueCount++;

                                                if (door.hasOwnProperty('doorStrips')) {
                                                    door.doorStrips ? trueCount++ : falseCount++;
                                                }

                                                if (door.hingesWorking) trueCount++; else falseCount++;
                                                if (door.hingesFireRating) trueCount++; else falseCount++;

                                                const damageMultiples = (door.damageMultiples || []).map(item => item.toString());
                                                if (damageMultiples.includes('None') && damageMultiples.length === 1) {
                                                    trueCount++;
                                                } else {
                                                    const isValidCondition =
                                                        (damageMultiples.includes('Door Pass') || !damageMultiples.includes('Door')) &&
                                                        (damageMultiples.includes('Frame Pass') || !damageMultiples.includes('Frame')) &&
                                                        (damageMultiples.includes('Glass None') || damageMultiples.includes('Glass Pass') || !damageMultiples.includes('Glass')) &&
                                                        (damageMultiples.includes('Ventilation Gaps None') || damageMultiples.includes('Ventilation Gaps Pass') || !damageMultiples.includes('Ventilation Gaps'));
                                                    isValidCondition ? trueCount++ : falseCount++;
                                                }

                                                const doorCertif = door.doorCertif || '';
                                                doorCertif && !doorCertif.includes('No') ? trueCount++ : falseCount++;

                                                condition1 && condition2 ? trueCount++ : falseCount++;

                                                if (door.requiresAttention) reqAttentionCount++;
                                                if (door.hasAccess === false) hasAccessCount++;

                                                if (reqAttentionCount === 0 && hasAccessCount === 0) {
                                                    falseCount >= 1 ? totalFalseCount++ : totalTrueCount++;
                                                }
                                                if (reqAttentionCount >= 1) totalReqAttentionCount++;
                                                if (hasAccessCount >= 1) totalHasAccessCount++;
                                            });
                                        }

                                        const formattedDate = formatDate(reportInfo.dateUpdated) || formatDate(reportInfo.date);
                                        const formattedNextDate = formatDate(reportInfo.nextDate);
                                        const hasPreviousReports = buildingsWithPreviousReports.includes(buildingName);
                                        const totalDoors = totalTrueCount + totalFalseCount + totalReqAttentionCount;

                                        return (
                                            <div className="col-lg-3 col-md-6 col-12 mb-4" key={uid} id={`building-${uid}`}>
                                                <div className={`building-card premium-design ${!hasLoaded ? '' :
                                                    totalFalseCount === 0 ? 'status-compliant' : 'status-critical'
                                                    }`}>

                                                    <div className="card-header-wrapper">
                                                        <div className="media-container">
                                                            {reportInfo.buildingVideoLink ? (
                                                                <video autoPlay muted loop playsInline
                                                                    onClick={() => hasLoaded && handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount)}
                                                                    className="premium-media"
                                                                >
                                                                    <source src={reportInfo.buildingVideoLink} type="video/mp4" />
                                                                </video>
                                                            ) : (
                                                                <img
                                                                    src={getImageSrc(reportInfo.buildingLink)}
                                                                    alt={buildingName}
                                                                    className="premium-media"
                                                                    onClick={() => hasLoaded && handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount)}
                                                                />
                                                            )}
                                                            <div className="media-gradient-overlay" />
                                                            <div className="media-shine-effect" />
                                                        </div>

                                                        <div className="card-top-bar">
                                                            <div className={`status-pill ${!hasLoaded ? 'pill-neutral' :
                                                                totalFalseCount === 0 ? 'pill-success' : 'pill-error'
                                                                }`}>
                                                                <div className="status-dot" />
                                                                <span className="status-text">
                                                                    {!hasLoaded
                                                                        ? <><span className="spinner-border spinner-border-sm me-1" style={{ width: '10px', height: '10px' }} /> Loading…</>
                                                                        : totalFalseCount === 0
                                                                            ? 'Fully Compliant'
                                                                            : `${totalFalseCount} Critical Issue${totalFalseCount !== 1 ? 's' : ''}`}
                                                                </span>
                                                            </div>

                                                            <div className="action-buttons">
                                                                {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'coordinator') && (
                                                                    <FontAwesomeIcon
                                                                        icon={faEdit}
                                                                        className="ms-2"
                                                                        title="Edit"
                                                                        style={{
                                                                            backgroundColor: '#ffffff', color: '#dc3545', cursor: 'pointer',
                                                                            fontSize: '1.1rem', padding: '3px', borderRadius: '4px', border: '1px solid #dc3545',
                                                                        }}
                                                                        onClick={() => {
                                                                            const selected = Object.values(data).find(b => b.reportInfo?.uid === reportInfo.uid);
                                                                            if (selected) { setSelectedReport(selected.reportInfo); setShowDetailsModal(true); }
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="card-content-premium">
                                                        <div className="building-header">
                                                            <div className="building-info">
                                                                <h3 className="building-title" title={buildingName}>{buildingName}</h3>
                                                            </div>
                                                        </div>

                                                        <div className="progress-section" style={{ opacity: hasLoaded ? 1 : 0.35 }}>
                                                            <div className="progress-header">
                                                                <span className="progress-title">Compliance Progress</span>
                                                                <span className="progress-stats">
                                                                    {hasLoaded ? `${totalTrueCount}/${totalDoors} items` : '0/0 items'}
                                                                </span>
                                                            </div>
                                                            <div className="progress-track">
                                                                <div
                                                                    className="progress-fill"
                                                                    style={{
                                                                        width: hasLoaded && totalDoors > 0
                                                                            ? `${(totalTrueCount / totalDoors) * 100}%`
                                                                            : '0%',
                                                                        background: !hasLoaded
                                                                            ? 'var(--color-border-secondary)'
                                                                            : totalFalseCount === 0
                                                                                ? 'linear-gradient(90deg, #10b981, #22c55e)'
                                                                                : totalFalseCount > 5
                                                                                    ? 'linear-gradient(90deg, #ef4444, #dc2626)'
                                                                                    : 'linear-gradient(90deg, #f59e0b, #eab308)',
                                                                    }}
                                                                >
                                                                    {hasLoaded && <div className="progress-glow" />}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="metrics-grid" style={{ opacity: hasLoaded ? 1 : 0.35, pointerEvents: hasLoaded ? 'auto' : 'none' }}>
                                                            <div className="metric-card success" onClick={() => hasLoaded && handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount, 'pass')}>
                                                                <div className="metric-top">
                                                                    <div className="metric-icon">
                                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" />
                                                                            <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                    </div>
                                                                    <span className="metric-value">{hasLoaded ? totalTrueCount : 0}</span>
                                                                </div>
                                                                <span className="metric-label">Pass</span>
                                                            </div>

                                                            <div className="metric-card critical" onClick={() => hasLoaded && handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount, 'fail')}>
                                                                <div className="metric-top">
                                                                    <div className="metric-icon">
                                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" />
                                                                            <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
                                                                            <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
                                                                        </svg>
                                                                    </div>
                                                                    <span className="metric-value">{hasLoaded ? totalFalseCount : 0}</span>
                                                                </div>
                                                                <span className="metric-label">Fail</span>
                                                            </div>

                                                            <div className="metric-card warning" onClick={() => hasLoaded && handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount, 'reinspection')}>
                                                                <div className="metric-top">
                                                                    <div className="metric-icon">
                                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                            <path d="M21 12a9 9 0 11-3.51-7.09L21 8M21 8V3m0 5h-5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                    </div>
                                                                    <span className="metric-value">{hasLoaded ? totalReqAttentionCount : 0}</span>
                                                                </div>
                                                                <span className="metric-label">Re-Inspection</span>
                                                            </div>

                                                            <div className="metric-card neutral" onClick={() => hasLoaded && handleReportClick(reportInfo.uid, reportInfo, totalFalseCount, totalTrueCount, 'no_access')}>
                                                                <div className="metric-top">
                                                                    <div className="metric-icon">
                                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1" />
                                                                            <line x1="5.636" y1="5.636" x2="18.364" y2="18.364" stroke="currentColor" strokeWidth="1" />
                                                                        </svg>
                                                                    </div>
                                                                    <span className="metric-value">{hasLoaded ? totalHasAccessCount : 0}</span>
                                                                </div>
                                                                <span className="metric-label">No Access</span>
                                                            </div>
                                                        </div>

                                                        <div className="card-footer-premium">
                                                            <button
                                                                className="premium-action-btn"
                                                                disabled={!hasLoaded}
                                                                onClick={() =>
                                                                    hasLoaded &&
                                                                    handleReportClick(
                                                                        reportInfo.uid,
                                                                        reportInfo,
                                                                        totalFalseCount,
                                                                        totalTrueCount
                                                                    )
                                                                }
                                                            >
                                                                <span>View Full Report</span>
                                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                                    <path
                                                                        d="M9 5l7 7-7 7"
                                                                        stroke="currentColor"
                                                                        strokeWidth="1"
                                                                        strokeLinecap="round"
                                                                    />
                                                                </svg>
                                                            </button>

                                                            {(
                                                                ['admin', 'manager', 'inspection', 'coordinator', 'remedial'].includes(userData.role) ||
                                                                userData.uid === '6pml9u9AgdR9U0jaZHqq4bulQb73'
                                                            ) && (
                                                                    <button
                                                                        className="premium-action-btn escalation-btn"
                                                                        disabled={!hasLoaded}
                                                                        onClick={() => hasLoaded && handleEscalationStrategy(reportInfo)}
                                                                    >
                                                                        <span>Access Details</span>
                                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                                            <path
                                                                                d="M9 5l7 7-7 7"
                                                                                stroke="currentColor"
                                                                                strokeWidth="1"
                                                                                strokeLinecap="round"
                                                                            />
                                                                        </svg>
                                                                    </button>
                                                                )}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    })
                                }

                                <div className="col-12 mt-2 mb-2">
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{
                                            flex: 1,
                                            height: '4px',
                                            background: '#e9ecef',
                                            borderRadius: '99px',
                                            overflow: 'hidden',
                                        }}>
                                            <div style={{
                                                height: '100%',
                                                width: `${sortedFilteredData.length > 0 ? (visibleData.length / sortedFilteredData.length) * 100 : 0}%`,
                                                background: '#dc2626',
                                                borderRadius: '99px',
                                                transition: 'width 0.4s ease',
                                            }} />
                                        </div>
                                        <span style={{
                                            fontSize: '12px',
                                            color: 'var(--color-text-tertiary)',
                                            whiteSpace: 'nowrap',
                                            minWidth: '110px',
                                            textAlign: 'right',
                                        }}>
                                            <span style={{ color: 'var(--color-text-primary)', fontWeight: '500' }}>{visibleData.length}</span>
                                            {' '}of{' '}
                                            <span style={{ color: 'var(--color-text-primary)', fontWeight: '500' }}>{sortedFilteredData.length}</span>
                                            {' '}buildings
                                        </span>
                                    </div>
                                </div>

                                {hasMore && (
                                    <div className="col-12 text-center mt-3 mb-4">
                                        <button
                                            onClick={handleLoadMore}
                                            disabled={loadingMore}
                                            className={`btn ${loadingMore ? 'btn-outline-danger' : 'btn-danger'} px-5`}
                                            style={{ borderRadius: '12px', fontWeight: '500' }}
                                        >
                                            {loadingMore ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" style={{ width: '14px', height: '14px' }} />
                                                    Loading {Math.max(0, Math.min(20, sortedFilteredData.length - visibleCount))} buildings…
                                                </>
                                            ) : (
                                                <>
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="me-2">
                                                        <path d="M12 5v14m7-7H5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
                                                    </svg>
                                                    Load {Math.max(0, Math.min(20, sortedFilteredData.length - visibleCount))} more buildings
                                                </>
                                            )}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>


                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    contentLabel="Survey Modal"
                    className="custom-modal"
                    overlayClassName="custom-overlay"
                >
                    <div className="modal-content">
                        <div className="d-flex justify-content-between align-items-center">
                            <h3 className="mb-0">
                                {currentStep === 1 && "Select Buildings"}
                                {currentStep === 2 && "Select Inspector"}
                                {currentStep === 3 && "Inspection Date"}
                                {currentStep === 4 && "Submit Survey"}
                            </h3>
                            <div className="button-group" style={{
                                display: 'flex',
                                gap: '10px',
                                justifyContent: 'flex-end',
                            }}>
                                {currentStep > 1 && (
                                    <button
                                        className="back-btn"
                                        onClick={handleBackStep}
                                        style={{
                                            backgroundColor: "#f1f1f1",
                                            color: "#333",
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Back
                                    </button>
                                )}
                                {currentStep === 1 && (
                                    <button
                                        className="next-btn"
                                        onClick={handleNextStep}
                                        disabled={selectedBuildings.length === 0}
                                        style={{
                                            backgroundColor: "#4CAF50",
                                            color: "white",
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Next
                                    </button>
                                )}
                                {currentStep === 2 && (
                                    <button
                                        className="submit-btn"
                                        onClick={handleModalSubmit}
                                        style={{
                                            backgroundColor: "#4CAF50",
                                            color: "white",
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Submit
                                    </button>
                                )}
                                <button
                                    className="cancel-btn"
                                    onClick={() => setIsModalOpen(false)}
                                    style={{
                                        backgroundColor: "#f44336",
                                        color: "white",
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>


                        </div>
                        <div className="row" style={{ paddingTop: '20px' }}>
                            {currentStep === 1 &&
                                latestReportsByBuilding.map((building) => (
                                    <div className="col-lg-3 col-md-6 col-12 mb-4" key={building.uid} id={`building-${building.uid}`}>
                                        <div
                                            className={`card rounded-lg serviceCard ${selectedBuildings.includes(building.uid) ? 'selected' : ''}`}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleBuildingSelection(building.uid)}
                                        >
                                            <img
                                                src={building.buildingLink}
                                                alt={building.buildingName}
                                                className="card-img-top rounded-top"
                                                style={{
                                                    height: '200px',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                            <div className="card-body text-center">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h6
                                                        className="service__title"
                                                        style={{
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            display: '-webkit-box',
                                                            WebkitBoxOrient: 'vertical',
                                                            WebkitLineClamp: 2,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {building.buildingName}
                                                    </h6>
                                                    <p style={{ margin: 0, color: '#777', marginTop: '5px' }}>
                                                        Next Survey Due {getNextSurveyDate(building)}
                                                    </p>

                                                    <div onClick={(e) => e.stopPropagation()} >
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedBuildings.includes(building.uid)}
                                                            onChange={() => handleBuildingSelection(building.uid)}
                                                            style={{
                                                                width: '20px',
                                                                height: '20px',
                                                                cursor: 'pointer',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            {currentStep === 2 && (
                                <div className="inspector-selection">
                                    {inspectorInfos.length === 0 ? (
                                        <p>No inspectors available</p>
                                    ) : (
                                        <div className="row">
                                            {inspectorInfos.map((inspector) => (
                                                <div className="col-lg-3 col-md-4 col-6 mb-4" key={inspector.uid}>
                                                    <div
                                                        className={`inspector-card ${selectedInspector === inspector.uid ? 'selected' : ''}`}
                                                        onClick={() => handleInspectorSelection(inspector)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            border: '1px solid #ddd',
                                                            borderRadius: '35px',
                                                            padding: '15px',
                                                            backgroundColor: '#fff',
                                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                                        }}
                                                    >
                                                        <div className="text-center">
                                                            <img
                                                                src={inspector.photoURL || logo}
                                                                alt={inspector.name}
                                                                style={{
                                                                    width: '120px',
                                                                    height: '120px',
                                                                    // borderRadius: '50%',
                                                                    objectFit: 'contain',
                                                                    marginBottom: '10px',
                                                                }}
                                                            />
                                                            <p><b>Firechecked Expert</b></p>
                                                            <p style={{
                                                                wordWrap: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                                textAlign: 'center',
                                                                marginBottom: '10px',
                                                            }}>
                                                                {inspector.email}
                                                            </p>

                                                            <input
                                                                type="checkbox"
                                                                checked={selectedInspector && selectedInspector.uid === inspector.uid}
                                                                readOnly
                                                                style={{
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    cursor: 'pointer',
                                                                    marginTop: '10px',
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}

                            {currentStep === 2 && (
                                <div>
                                    {/* <label htmlFor="inspectionDate">Select Inspection Date:</label>
                                    <input
                                        type="date"
                                        id="inspectionDate"
                                        value={inspectionDate}
                                        onChange={(e) => setInspectionDate(e.target.value)}
                                        style={{
                                            display: 'block',
                                            margin: '10px 0',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            width: '30%',
                                        }}
                                    /> */}

                                    <label htmlFor="email">Enter Email:</label>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            margin: '10px 0',
                                            width: window.innerWidth <= 768 ? 'auto' : '30%',
                                        }}
                                    >
                                        <input
                                            type="email"
                                            id="email"
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    addEmail(e.target.value);
                                                    e.target.value = '';
                                                    e.preventDefault();
                                                }
                                            }}
                                            style={{
                                                padding: '10px',
                                                borderRadius: '5px',
                                                border: '1px solid #ccc',
                                                flex: 1,
                                            }}
                                        />
                                        <button
                                            onClick={() => {
                                                const input = document.getElementById('email');
                                                addEmail(input.value);
                                                input.value = '';
                                            }}
                                            style={{
                                                padding: '10px 15px',
                                                backgroundColor: "#4CAF50",
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '5px',
                                                cursor: 'pointer',
                                                marginLeft: '10px',
                                            }}
                                        >
                                            Add Email
                                        </button>
                                    </div>



                                    {emails.length > 0 ? (
                                        <div style={{
                                            marginTop: '20px', padding: '20px', backgroundColor: '#f9f9f9', width: window.innerWidth <= 768 ? 'auto' : '30%',
                                            borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                                        }}>
                                            <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px' }}>Entered Emails:</h4>

                                            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                                                {emails.map((email, index) => (
                                                    <li
                                                        key={index}
                                                        style={{
                                                            marginBottom: '15px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            padding: '10px',
                                                            backgroundColor: '#fff',
                                                            borderRadius: '6px',
                                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                        }}
                                                    >
                                                        <span style={{ flex: 1, fontSize: '16px', color: '#333' }}>{email}</span>
                                                        <button
                                                            onClick={() => removeEmail(index)}
                                                            style={{
                                                                marginLeft: '15px',
                                                                backgroundColor: '#ff4d4d',
                                                                color: '#fff',
                                                                border: 'none',
                                                                borderRadius: '5px',
                                                                padding: '8px 15px',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.3s ease',
                                                            }}
                                                            onMouseOver={(e) => e.target.style.backgroundColor = '#ff3333'}
                                                            onMouseOut={(e) => e.target.style.backgroundColor = '#ff4d4d'}
                                                        >
                                                            Remove
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ) : (
                                        <p style={{ fontStyle: 'italic', color: '#888' }}>
                                            No emails entered. Please add an email to proceed.
                                        </p>
                                    )}
                                </div>
                            )}



                        </div>
                    </div>
                </Modal>
                <ToastContainer autoClose={1000} />


                <Modal
                    isOpen={isModalOpen1}
                    onRequestClose={() => setIsModalOpen1(false)}
                    contentLabel="Survey Modal 2"
                    className="custom-modal"
                    overlayClassName="custom-overlay"
                >
                    <div className="modal-content">
                        <div className="d-flex justify-content-between align-items-center">
                            <h3 className="mb-0">
                                {currentStep1 === 1 && "Select Buildings"}
                                {currentStep1 === 2 && "Select Doors"}
                                {currentStep1 === 3 && "Select Inspector"}
                                {currentStep1 === 4 && "Inspection Date"}
                            </h3>
                            <div className="button-group" style={{ display: 'flex', gap: '10px' }}>
                                {currentStep1 > 1 && (
                                    <button
                                        className="back-btn"
                                        onClick={handleBackStep1}
                                        style={{
                                            backgroundColor: "#f1f1f1",
                                            color: "#333",
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Back
                                    </button>
                                )}
                                {currentStep1 === 1 && (
                                    <button
                                        className="next-btn"
                                        onClick={handleNextStep1}
                                        disabled={selectedBuildings1.length === 0}
                                        style={{
                                            backgroundColor: "#4CAF50",
                                            color: "white",
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Next
                                    </button>
                                )}
                                {currentStep1 === 2 && (
                                    <button
                                        className="next-btn"
                                        onClick={handleNextStep1}
                                        disabled={
                                            selectedBuildings1.length === 0 ||
                                            selectedBuildings1.some((buildingId) =>
                                                !selectedBuildingsDoor[buildingId] || selectedBuildingsDoor[buildingId].length === 0
                                            )
                                        }
                                        style={{
                                            backgroundColor: "#4CAF50",
                                            color: "white",
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Next
                                    </button>
                                )}
                                {currentStep1 === 3 && (
                                    <button
                                        className="submit-btn"
                                        onClick={handleModalSubmit1}
                                        style={{
                                            backgroundColor: "#4CAF50",
                                            color: "white",
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Submit
                                    </button>
                                )}
                                <button
                                    className="cancel-btn"
                                    onClick={() => setIsModalOpen1(false)}
                                    style={{
                                        backgroundColor: "#f44336",
                                        color: "white",
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>

                        <div className="row" style={{ paddingTop: '20px' }}>

                            {currentStep1 === 1 && latestReportsByBuilding.map((building) => (
                                <div className="col-lg-3 col-md-6 col-12 mb-4" key={building.uid} id={`building-${building.uid}`}>
                                    <div
                                        className={`card rounded-lg serviceCard ${selectedBuildings1.includes(building.uid) ? 'selected' : ''}`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleBuildingSelection1(building.uid, building)}
                                    >
                                        <img
                                            src={building.buildingLink}
                                            alt={building.buildingName}
                                            className="card-img-top rounded-top"
                                            style={{
                                                height: '200px',
                                                objectFit: 'cover',
                                            }}
                                        />
                                        <div className="card-body text-center">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h6
                                                    className="service__title"
                                                    style={{
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        display: '-webkit-box',
                                                        WebkitBoxOrient: 'vertical',
                                                        WebkitLineClamp: 2,
                                                        margin: 0,
                                                    }}
                                                >
                                                    {building.buildingName}
                                                </h6>
                                                <p style={{ margin: 0, color: '#777', marginTop: '5px' }}>
                                                    Next Survey Due {getNextSurveyDate(building)}
                                                </p>
                                                <div onClick={(e) => e.stopPropagation()}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedBuildings1.includes(building.uid)}
                                                        onChange={() => handleBuildingSelection1(building.uid, building)}
                                                        style={{
                                                            width: '20px',
                                                            height: '20px',
                                                            cursor: 'pointer',
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}



                            {currentStep1 === 2 && selectedBuildings1.map((buildingId) => {
                                const building = latestReportsByBuilding.find((b) => b.uid === buildingId);
                                const doors = nestedReports[buildingId]?.doorReports || [];
                                const resi_doors = nestedReports[buildingId]?.resiReports || [];

                                if (!building) {
                                    return null;
                                }

                                //communal
                                const doorfilter = doorFilters[buildingId] || 'All';

                                const sortedDoors = doors.sort((a, b) => new Date(a.date) - new Date(b.date));

                                const doorsWithOriginalIndex = sortedDoors.map((door, index) => {
                                    return { ...door, originalIndex: index };
                                });


                                const filteredDoors = doorsWithOriginalIndex.filter((door) => {
                                    let trueCount = 0;
                                    let falseCount = 0;

                                    const d1 = parseFloat(door.fD1) || 0;
                                    const d2 = parseFloat(door.fD2) || 0;
                                    const d3 = parseFloat(door.fD3) || 0;
                                    const d4 = parseFloat(door.fD4) || 0;

                                    const condition1 = (d1 <= 4 && d2 <= 4 && d3 <= 4);
                                    const condition2 = (d4 <= 8);

                                    if (door.doorCloseAsIntented === false) {
                                        falseCount++;
                                    } else {
                                        trueCount++;
                                    }

                                    if (door.hasOwnProperty('doorStrips')) {
                                        const doorStrips = door.doorStrips;
                                        if (doorStrips) {
                                            trueCount++;
                                        } else {
                                            falseCount++;
                                        }
                                    }

                                    if (door.hingesWorking) trueCount++; else falseCount++;
                                    if (door.hingesFireRating) trueCount++; else falseCount++;

                                    const damageMultiples = (door.damageMultiples || []).map(item => item.toString());
                                    if (damageMultiples.includes('None') && damageMultiples.length === 1) {
                                        trueCount++;
                                    } else {
                                        const isValidCondition = (damageMultiples.includes('Door Pass') || !damageMultiples.includes('Door')) &&
                                            (damageMultiples.includes('Frame Pass') || !damageMultiples.includes('Frame')) &&
                                            (damageMultiples.includes('Glass None') || damageMultiples.includes('Glass Pass') || !damageMultiples.includes('Glass')) &&
                                            (damageMultiples.includes('Ventilation Gaps None') || damageMultiples.includes('Ventilation Gaps Pass') || !damageMultiples.includes('Ventilation Gaps'));

                                        if (isValidCondition) {
                                            trueCount++;
                                        } else {
                                            falseCount++;
                                        }
                                    }

                                    const doorCertif = door.doorCertif || '';
                                    if (doorCertif && !doorCertif.includes('No')) {
                                        trueCount++;
                                    } else {
                                        falseCount++;
                                    }

                                    if (condition1 && condition2) {
                                        trueCount++;
                                    } else {
                                        falseCount++;
                                    }

                                    const doorStatus = falseCount >= 1 ? 'Failed' : 'Passed';

                                    if (doorfilter === 'All') {
                                        return true;
                                    }
                                    if (doorfilter === 'Passed' && doorStatus === 'Passed') {
                                        return true;
                                    }
                                    if (doorfilter === 'Failed' && doorStatus === 'Failed') {
                                        return true;
                                    }

                                    return false;
                                });

                                //resi
                                const resi_doorfilter = resiDoorFilters[buildingId] || 'All';

                                const resi_sortedDoors = resi_doors.sort((a, b) => new Date(a.date) - new Date(b.date));

                                const resi_doorsWithOriginalIndex = resi_sortedDoors.map((door, index) => {
                                    return { ...door, originalIndex: index };
                                });


                                const resi_filteredDoors = resi_doorsWithOriginalIndex.filter((door) => {
                                    let trueCount = 0;
                                    let falseCount = 0;

                                    const d1 = parseFloat(door.fD1) || 0;
                                    const d2 = parseFloat(door.fD2) || 0;
                                    const d3 = parseFloat(door.fD3) || 0;
                                    const d4 = parseFloat(door.fD4) || 0;

                                    const condition1 = (d1 <= 4 && d2 <= 4 && d3 <= 4);
                                    const condition2 = (d4 <= 8);

                                    if (door.doorCloseAsIntented === false) {
                                        falseCount++;
                                    } else {
                                        trueCount++;
                                    }

                                    if (door.hasOwnProperty('doorStrips')) {
                                        const doorStrips = door.doorStrips;
                                        if (doorStrips) {
                                            trueCount++;
                                        } else {
                                            falseCount++;
                                        }
                                    }

                                    if (door.hingesWorking) trueCount++; else falseCount++;
                                    if (door.hingesFireRating) trueCount++; else falseCount++;

                                    const damageMultiples = (door.damageMultiples || []).map(item => item.toString());
                                    if (damageMultiples.includes('None') && damageMultiples.length === 1) {
                                        trueCount++;
                                    } else {
                                        const isValidCondition = (damageMultiples.includes('Door Pass') || !damageMultiples.includes('Door')) &&
                                            (damageMultiples.includes('Frame Pass') || !damageMultiples.includes('Frame')) &&
                                            (damageMultiples.includes('Glass None') || damageMultiples.includes('Glass Pass') || !damageMultiples.includes('Glass')) &&
                                            (damageMultiples.includes('Ventilation Gaps None') || damageMultiples.includes('Ventilation Gaps Pass') || !damageMultiples.includes('Ventilation Gaps'));

                                        if (isValidCondition) {
                                            trueCount++;
                                        } else {
                                            falseCount++;
                                        }
                                    }

                                    const doorCertif = door.doorCertif || '';
                                    if (doorCertif && !doorCertif.includes('No')) {
                                        trueCount++;
                                    } else {
                                        falseCount++;
                                    }

                                    if (condition1 && condition2) {
                                        trueCount++;
                                    } else {
                                        falseCount++;
                                    }

                                    const resi_doorStatus = falseCount >= 1 ? 'Failed' : 'Passed';

                                    if (resi_doorfilter === 'All') {
                                        return true;
                                    }
                                    if (resi_doorfilter === 'Passed' && resi_doorStatus === 'Passed') {
                                        return true;
                                    }
                                    if (resi_doorfilter === 'Failed' && resi_doorStatus === 'Failed') {
                                        return true;
                                    }

                                    return false;
                                });

                                return (
                                    <div key={buildingId}>
                                        <h4
                                            style={{
                                                fontSize: '32px',
                                                fontWeight: 'bold',
                                                color: '#fff',
                                                marginBottom: '20px',
                                                padding: '15px',
                                                backgroundColor: '#4CAF50',
                                                borderRadius: '5px',
                                                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {building.buildingName}
                                        </h4>

                                        <Tabs
                                            id="door-tabs"
                                            activeKey={key}
                                            onSelect={(k) => setKey(k)}
                                            className="mb-3"
                                        >
                                            <Tab eventKey="communal" title={<span style={{ color: 'red' }}>Communal Doors</span>} >
                                                <div className="tab-content">
                                                    <div className="tab-pane fade show active" id={`communal-${buildingId}`} role="tabpanel">
                                                        <div className="d-flex justify-content-end align-items-center mb-3">
                                                            <button
                                                                className={`btn btn-sm ${doorfilter === 'All' ? 'btn-primary' : 'btn-outline-primary'} me-2`}
                                                                onClick={() => handleBuildingFilterChange(buildingId, 'All')}
                                                            >
                                                                All Doors
                                                            </button>

                                                            <button
                                                                className={`btn btn-sm ${doorfilter === 'Passed' ? 'btn-success' : 'btn-outline-success'} me-2`}
                                                                onClick={() => handleBuildingFilterChange(buildingId, 'Passed')}
                                                            >
                                                                Passed Doors
                                                            </button>

                                                            <button
                                                                className={`btn btn-sm ${doorfilter === 'Failed' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                onClick={() => handleBuildingFilterChange(buildingId, 'Failed')}
                                                            >
                                                                Failed Doors
                                                            </button>
                                                        </div>

                                                        <div className="row">
                                                            {filteredDoors.length > 0 ? (
                                                                filteredDoors
                                                                    // .sort((a, b) => new Date(a.date) - new Date(b.date))
                                                                    .map((door) => (
                                                                        <div className="col-lg-2 col-md-3 col-sm-6 col-6 mb-4" key={door.uid}>
                                                                            <div
                                                                                className={`door-card ${selectedBuildingsDoor[buildingId]?.includes(door.uid) ? 'selected' : ''}`}
                                                                                onClick={() => handleDoorSelection1(door.uid, buildingId, door)}
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '15px',
                                                                                    padding: '20px',
                                                                                    backgroundColor: '#fff',
                                                                                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                                                                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                                                                    marginBottom: '15px',
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    justifyContent: 'space-between',
                                                                                    height: '100%',
                                                                                }}
                                                                            >
                                                                                <div className="image-container" style={{ marginBottom: '15px' }}>
                                                                                    <img
                                                                                        src={door.doorPullPhotoLink}
                                                                                        alt={door.doorLocation}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            height: '180px',
                                                                                            objectFit: 'contain',
                                                                                            borderRadius: '8px',
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                                    <div>
                                                                                        <h6 className="service__title">
                                                                                            {door.doorNumber ? door.doorNumber : `C${door.originalIndex + 1}`}
                                                                                        </h6>
                                                                                        <p style={{ marginBottom: '0', fontSize: '14px', color: '#777' }}>Level: {door.doorLevel}</p>
                                                                                    </div>
                                                                                    <div onClick={(e) => e.stopPropagation()} style={{ marginLeft: '10px' }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={selectedBuildingsDoor[buildingId]?.includes(door.uid)}
                                                                                            onChange={() => handleDoorSelection1(door.uid, buildingId, door)}
                                                                                            style={{
                                                                                                width: '20px',
                                                                                                height: '20px',
                                                                                                cursor: 'pointer',
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                            ) : (
                                                                <p>No communal doors available for this building.</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab>
                                            {/* Residential */}
                                            <Tab eventKey="residential" title={<span style={{ color: 'red' }}>Residential Doors</span>} >
                                                <div className="tab-content">
                                                    <div className="tab-pane fade show active" id={`residential-${buildingId}`} role="tabpanel">
                                                        <div className="d-flex justify-content-end align-items-center mb-3">
                                                            <button
                                                                className={`btn btn-sm ${resi_doorfilter === 'All' ? 'btn-primary' : 'btn-outline-primary'} me-2`}
                                                                onClick={() => handleBuildingFilterChange1(buildingId, 'All')}
                                                            >
                                                                All Doors
                                                            </button>

                                                            <button
                                                                className={`btn btn-sm ${resi_doorfilter === 'Passed' ? 'btn-success' : 'btn-outline-success'} me-2`}
                                                                onClick={() => handleBuildingFilterChange1(buildingId, 'Passed')}
                                                            >
                                                                Passed Doors
                                                            </button>

                                                            <button
                                                                className={`btn btn-sm ${resi_doorfilter === 'Failed' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                onClick={() => handleBuildingFilterChange1(buildingId, 'Failed')}
                                                            >
                                                                Failed Doors
                                                            </button>
                                                        </div>

                                                        <div className="row">
                                                            {resi_filteredDoors.length > 0 ? (
                                                                resi_filteredDoors
                                                                    // .sort((a, b) => new Date(a.date) - new Date(b.date))
                                                                    .map((door) => (
                                                                        <div className="col-lg-2 col-md-3 col-sm-6 col-6 mb-4" key={door.uid}>
                                                                            <div
                                                                                className={`door-card ${selectedBuildingsDoor[buildingId]?.includes(door.uid) ? 'selected' : ''}`}
                                                                                onClick={() => handleDoorSelection1(door.uid, buildingId, door)}
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '15px',
                                                                                    padding: '20px',
                                                                                    backgroundColor: '#fff',
                                                                                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                                                                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                                                                    marginBottom: '15px',
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    justifyContent: 'space-between',
                                                                                    height: '100%',
                                                                                }}
                                                                            >
                                                                                <div className="image-container" style={{ marginBottom: '15px' }}>
                                                                                    <img
                                                                                        src={door.doorPullPhotoLink}
                                                                                        alt={door.doorLocation}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            height: '180px',
                                                                                            objectFit: 'contain',
                                                                                            borderRadius: '8px',
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                                    <div>
                                                                                        <h6 className="service__title">
                                                                                            {door.doorNumber ? door.doorNumber : `R${door.originalIndex + 1}`}
                                                                                        </h6>
                                                                                        <p style={{ marginBottom: '0', fontSize: '14px', color: '#777' }}>Level: {door.doorLevel}</p>
                                                                                    </div>
                                                                                    <div onClick={(e) => e.stopPropagation()} style={{ marginLeft: '10px' }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={selectedBuildingsDoor[buildingId]?.includes(door.uid)}
                                                                                            onChange={() => handleDoorSelection1(door.uid, buildingId, door)}
                                                                                            style={{
                                                                                                width: '20px',
                                                                                                height: '20px',
                                                                                                cursor: 'pointer',
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                            ) : (
                                                                <p>No residential doors available for this building.</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab>
                                        </Tabs>
                                    </div>
                                );
                            })}

                            {currentStep1 === 3 && (
                                <div className="inspector-selection">
                                    {inspectorInfos.length === 0 ? (
                                        <p>No inspectors available</p>
                                    ) : (
                                        <div className="row">
                                            {inspectorInfos.map((inspector) => (
                                                <div className="col-lg-3 col-md-4 col-6 mb-4" key={inspector.uid}>
                                                    <div
                                                        className={`inspector-card ${selectedInspector1 === inspector.uid ? 'selected' : ''}`}
                                                        onClick={() => handleInspectorSelection1(inspector)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            border: '1px solid #ddd',
                                                            borderRadius: '35px',
                                                            padding: '15px',
                                                            backgroundColor: '#fff',
                                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                                        }}
                                                    >
                                                        <div className="text-center">
                                                            <img
                                                                src={inspector.photoURL || logo}
                                                                alt={inspector.name}
                                                                style={{
                                                                    width: '120px',
                                                                    height: '120px',
                                                                    // borderRadius: '50%',
                                                                    objectFit: 'contain',
                                                                    marginBottom: '10px',
                                                                }}
                                                            />
                                                            <p><b>Firechecked Expert</b></p>
                                                            <p style={{
                                                                wordWrap: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                                textAlign: 'center',
                                                                marginBottom: '10px',
                                                            }}>
                                                                {inspector.email}
                                                            </p>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedInspector1 && selectedInspector1.uid === inspector.uid}
                                                                onChange={() => handleInspectorSelection1(inspector)}
                                                                style={{
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    cursor: 'pointer',
                                                                    marginTop: '10px',
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}

                            {currentStep1 === 3 && (
                                <div>
                                    <label htmlFor="email">Enter Email:</label>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            margin: '10px 0',
                                            width: window.innerWidth <= 768 ? 'auto' : '30%',
                                        }}
                                    >
                                        <input
                                            type="email"
                                            id="email"
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    addEmail(e.target.value);
                                                    e.target.value = '';
                                                    e.preventDefault();
                                                }
                                            }}
                                            style={{
                                                padding: '10px',
                                                borderRadius: '5px',
                                                border: '1px solid #ccc',
                                                flex: 1,
                                            }}
                                        />
                                        <button
                                            onClick={() => {
                                                const input = document.getElementById('email');
                                                addEmail(input.value);
                                                input.value = '';
                                            }}
                                            style={{
                                                padding: '10px 15px',
                                                backgroundColor: "#4CAF50",
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '5px',
                                                cursor: 'pointer',
                                                marginLeft: '10px',
                                            }}
                                        >
                                            Add Email
                                        </button>
                                    </div>


                                    {emails.length > 0 ? (
                                        <div style={{
                                            marginTop: '20px', padding: '20px', backgroundColor: '#f9f9f9', width: window.innerWidth <= 768 ? 'auto' : '30%',
                                            borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                                        }}>
                                            <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px' }}>Entered Emails:</h4>

                                            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                                                {emails.map((email, index) => (
                                                    <li
                                                        key={index}
                                                        style={{
                                                            marginBottom: '15px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            padding: '10px',
                                                            backgroundColor: '#fff',
                                                            borderRadius: '6px',
                                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                        }}
                                                    >
                                                        <span style={{ flex: 1, fontSize: '16px', color: '#333' }}>{email}</span>
                                                        <button
                                                            onClick={() => removeEmail(index)}
                                                            style={{
                                                                marginLeft: '15px',
                                                                backgroundColor: '#ff4d4d',
                                                                color: '#fff',
                                                                border: 'none',
                                                                borderRadius: '5px',
                                                                padding: '8px 15px',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.3s ease',
                                                            }}
                                                            onMouseOver={(e) => e.target.style.backgroundColor = '#ff3333'}
                                                            onMouseOut={(e) => e.target.style.backgroundColor = '#ff4d4d'}
                                                        >
                                                            Remove
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ) : (
                                        <p style={{ fontStyle: 'italic', color: '#888' }}>
                                            No emails entered. Please add an email to proceed.
                                        </p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </Modal>

                <ContactModal
                    show={showInviteModal}
                    onClose={() => setShowInviteModal(false)}
                />


                <BootstrapModal
                    className="details-modal"
                    show={showDetailsModal}
                    onHide={() => setShowDetailsModal(false)}
                    centered={!isMobile}
                    backdrop="static"
                    keyboard={false}
                    size="xl"
                    scrollable
                >
                    <BootstrapModal.Header className="d-flex justify-content-between align-items-center">
                        <BootstrapModal.Title>
                            Edit {selectedReport?.buildingName || "Building"} Details
                        </BootstrapModal.Title>

                        <div className="form-check form-switch d-flex align-items-center gap-2 mb-0 pb-2 me-3">
                            <input
                                id="autoScheduleSwitch"
                                name="autoSchedule"
                                type="checkbox"
                                role="switch"
                                value="true"
                                form="editReportForm"
                                className="form-check-input m-2"
                                style={{ cursor: "pointer" }}
                                checked={autoSchedule}
                                onChange={(e) => setAutoSchedule(e.target.checked)}
                            />
                            <label
                                htmlFor="autoScheduleSwitch"
                                className="form-check-label mb-0"
                                style={{ cursor: "pointer" }}
                            >
                                Auto Schedule
                            </label>
                        </div>
                    </BootstrapModal.Header>

                    <BootstrapModal.Body>
                        <Form ref={formRef}>
                            {/* <Tabs
                                defaultActiveKey="section1"
                                id="building-details-tabs"
                                activeKey={activeTab}
                                onSelect={(k) => setActiveTab(k)}
                                className="mb-3 border-bottom"
                                style={{
                                    display: "flex",
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                    whiteSpace: "nowrap",
                                    width: "100%",
                                    flexWrap: "nowrap",
                                    paddingLeft: "1rem",
                                    gap: '1rem',
                                    scrollPaddingLeft: "1rem",
                                }}
                            >
                                <Tab
                                    style={{ minHeight: '630px', maxHeight: '630px' }}
                                    eventKey="section1"
                                    title={
                                        <span
                                            className="text-danger"
                                            style={{
                                                fontSize: window.innerWidth < 768 ? '0.8rem' : '1.1rem',
                                            }}
                                        >
                                            Building Info
                                        </span>
                                    }
                                > */}
                            <div className="mb-2 px-2 py-1 bg-light border-start border-danger border-3">
                                <small className="text-muted fw-bold">PROPERTY & REPORT</small>
                            </div>
                            <Row>
                                <Col md={3}>
                                    <Form.Group controlId="propertySurveyed" className="mb-3">
                                        <Form.Label>Property Surveyed *</Form.Label>
                                        <Form.Control
                                            name="propertySurveyed"
                                            type="text"
                                            placeholder="e.g. Building Name"
                                            onChange={(e) => {
                                                const reportInput = document.querySelector('input[name="reportId"]');
                                                if (reportInput) {
                                                    reportInput.value = e.target.value
                                                        ? `${e.target.value} Fire Door Report 1`
                                                        : "";
                                                }
                                            }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="reportId" className="mb-3">
                                        <Form.Label>Report ID *</Form.Label>
                                        <Form.Control
                                            name="reportId"
                                            type="text"
                                            placeholder="Enter Report ID"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="completedBy" className="mb-3">
                                        <Form.Label>
                                            Report Inspected By
                                            {/* <span
                                                    className="ms-2 text-muted"
                                                    style={{ fontSize: '0.75rem', fontStyle: 'italic' }}
                                                    title="Leave blank to auto-assign to current user"
                                                >
                                                    (optional - auto-assigns)
                                                </span> */}
                                        </Form.Label>
                                        <CreatableSelect
                                            options={inspectores}
                                            value={selectedBuildingInspector}
                                            onChange={setSelectedBuildingInspector}
                                            placeholder="Select inspector"
                                            isClearable
                                            isSearchable
                                            menuPlacement="auto"
                                            menuPosition="fixed"
                                            menuPortalTarget={document.body}
                                            formatCreateLabel={inputValue => `Add "${inputValue}"`}
                                            styles={selectStyles}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="buildingType" className="mb-3">
                                        <Form.Label>Building Type *</Form.Label>
                                        <Select
                                            name="buildingType"
                                            options={buildingTypeOptions}
                                            value={selectedBuildingType}
                                            onChange={setSelectedBuildingType}
                                            placeholder="Select Building Type"
                                            isClearable
                                            isSearchable
                                            menuPlacement="auto"
                                            menuPosition="fixed"
                                            menuPortalTarget={document.body}
                                            styles={selectStyles}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="mb-2 px-2 py-1 bg-light border-start border-danger border-3">
                                <small className="text-muted fw-bold">LOCATION & STRUCTURE</small>
                            </div>
                            <Row>
                                <Col md={3}>
                                    <Form.Group controlId="buildingAddress" className="mb-3">
                                        <Form.Label>Building Address *</Form.Label>
                                        <Form.Control
                                            name="buildingAddress"
                                            type="text"
                                            placeholder="Building Address"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="buildingCity" className="mb-3">
                                        <Form.Label>Building City *</Form.Label>
                                        <Form.Control
                                            name="buildingCity"
                                            type="text"
                                            placeholder="City"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="buildingPostcode" className="mb-3">
                                        <Form.Label>Building Postcode *</Form.Label>
                                        <Form.Control
                                            name="buildingPostcode"
                                            type="text"
                                            placeholder="Postcode"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="floors" className="mb-3">
                                        <Form.Label>Number of Floors *</Form.Label>
                                        <Form.Control
                                            name="floors"
                                            type="number"
                                            placeholder="e.g. 3"
                                            min={1}
                                            onInput={(e) => {
                                                if (e.target.value < 1) e.target.value = 1;
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="mb-2 px-2 py-1 bg-light border-start border-danger border-3">
                                <small className="text-muted fw-bold">CLIENT INFORMATION</small>
                            </div>
                            <Row>
                                <Col md={3}>
                                    <Form.Group controlId="clientName" className="mb-3">
                                        <Form.Label>Client Name *</Form.Label>
                                        <Form.Control
                                            name="clientName"
                                            type="text"
                                            placeholder="Client Name"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="email" className="mb-3">
                                        <Form.Label>Client Email *</Form.Label>
                                        <Form.Control
                                            name="email"
                                            type="email"
                                            placeholder="Client Email"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="accountablePerson" className="mb-3">
                                        <Form.Label>Responsible Person *</Form.Label>
                                        <Form.Control
                                            name="accountablePerson"
                                            type="text"
                                            placeholder="Name of Responsible Person"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="mb-2 px-2 py-1 bg-light border-start border-danger border-3">
                                <small className="text-muted fw-bold">DOORS & ATTACHMENTS</small>
                            </div>
                            <Row>
                                <Col md={3}>
                                    <Form.Group controlId="totalCommunalDoors" className="mb-3">
                                        <Form.Label>Number of Communal Doors</Form.Label>
                                        <Form.Control
                                            name="totalCommunalDoors"
                                            type="text"
                                            placeholder="Number of Communal Doors"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="totalResiDoors" className="mb-3">
                                        <Form.Label>Number of Residential Doors</Form.Label>
                                        <Form.Control
                                            name="totalResiDoors"
                                            type="text"
                                            placeholder="Number of Residential Doors"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="buildingPhoto" className="mb-3">
                                        <Form.Label
                                            onMouseEnter={() => setHoverPhoto(true)}
                                            onMouseLeave={() => setHoverPhoto(false)}
                                            style={{ cursor: 'pointer', position: 'relative' }}
                                        >
                                            Photo of Building{' '}
                                            {(selectedReport?.buildingLink || newBuildingPhoto) && (
                                                <span
                                                    style={{
                                                        color: hoverPhoto ? '#000' : '#999',
                                                        transition: 'color 0.3s ease',
                                                    }}
                                                >
                                                    (Preview)
                                                </span>
                                            )}

                                            {hoverPhoto && (selectedReport?.buildingLink || newBuildingPhoto) && (
                                                <img
                                                    src={newBuildingPhoto ? URL.createObjectURL(newBuildingPhoto) : selectedReport.buildingLink}
                                                    alt="Building Preview"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        width: '200px',
                                                        maxHeight: '150px',
                                                        objectFit: 'cover',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px',
                                                        background: '#fff',
                                                        zIndex: 10,
                                                    }}
                                                />
                                            )}
                                        </Form.Label>

                                        <Form.Control
                                            name="buildingPhoto"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => setNewBuildingPhoto(e.target.files[0])}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="buildingLogo" className="mb-3">
                                        <Form.Label
                                            onMouseEnter={() => setHoverLogo(true)}
                                            onMouseLeave={() => setHoverLogo(false)}
                                            style={{ cursor: 'pointer', position: 'relative' }}
                                        >
                                            Logo of Building{' '}
                                            {(selectedReport?.logo || newBuildingLogo) && (
                                                <span
                                                    style={{
                                                        color: hoverLogo ? '#000' : '#999',
                                                        transition: 'color 0.3s ease',
                                                    }}
                                                >
                                                    (Preview)
                                                </span>
                                            )}

                                            {hoverLogo && (selectedReport?.logo || newBuildingLogo) && (
                                                <img
                                                    src={newBuildingLogo ? URL.createObjectURL(newBuildingLogo) : selectedReport.logo}
                                                    alt="Logo Preview"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        width: '150px',
                                                        maxHeight: '100px',
                                                        objectFit: 'contain',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px',
                                                        background: '#fff',
                                                        zIndex: 10,
                                                    }}
                                                />
                                            )}
                                        </Form.Label>

                                        <Form.Control
                                            name="buildingLogo"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => setNewBuildingLogo(e.target.files[0])}
                                        />
                                    </Form.Group>
                                </Col>


                            </Row>

                            <div className="mb-2 px-2 py-1 bg-light border-start border-danger border-3">
                                <small className="text-muted fw-bold">UPCOMING SCHEDULE</small>
                            </div>
                            <Row>
                                <Col md={3}>
                                    <Form.Group controlId="date" className="mb-3">
                                        <Form.Label>Planned visit date *</Form.Label>
                                        <Flatpickr
                                            name="date"
                                            className="form-control"
                                            value={plannedDate}
                                            onChange={([date]) => setPlannedDate(date)}
                                            options={{
                                                altInput: true,
                                                altFormat: "d/m/Y",
                                                dateFormat: "Y-m-d",
                                                monthSelectorType: "static",
                                                disableMobile: true,
                                            }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="" className="mb-3">
                                        <Form.Label>Next Communal Date</Form.Label>
                                        <Flatpickr
                                            name="nextCommunalSurveyDate"
                                            className="form-control"
                                            value={commDate}
                                            onChange={([date]) => setCommDate(date)}
                                            options={{
                                                altInput: true,
                                                altFormat: "d/m/Y",
                                                dateFormat: "Y-m-d",
                                                monthSelectorType: "static",
                                                disableMobile: true,
                                            }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="nextResidentialSurveyDate" className="mb-3">
                                        <Form.Label>Next Residential Date</Form.Label>
                                        <Flatpickr
                                            name="nextResidentialSurveyDate"
                                            className="form-control"
                                            value={resiDate}
                                            onChange={([date]) => setResiDate(date)}
                                            options={{
                                                altInput: true,
                                                altFormat: "d/m/Y",
                                                dateFormat: "Y-m-d",
                                                monthSelectorType: "static",
                                                disableMobile: true,
                                            }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="communalMonths" className="mb-3">
                                        <Form.Label>Communal Months Override</Form.Label>
                                        <Form.Control
                                            name="communalMonths"
                                            type="number"
                                            placeholder="e.g. 6"
                                            min={1}
                                            onInput={(e) => {
                                                if (e.target.value < 1) e.target.value = 1;
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="mb-2 px-2 py-1 bg-light border-start border-danger border-3">
                                <small className="text-muted fw-bold">CONCIERGE, PARKING & ACCESS INFO</small>
                            </div>
                            <Row>
                                <Col md={3}>
                                    <Form.Group controlId="conciergeDetails" className="mb-3">
                                        <Form.Label>Concierge Details</Form.Label>
                                        <Form.Control
                                            name="conciergeDetails"
                                            type="text"
                                            placeholder="Enter concierge info"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="parkingInfo" className="mb-3">
                                        <Form.Label>Parking Info</Form.Label>
                                        <Form.Control
                                            name="parkingInfo"
                                            type="text"
                                            placeholder="Enter parking info"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group controlId="accessInfo" className="mb-3">
                                        <Form.Label>Access Info</Form.Label>
                                        <Form.Control
                                            name="accessInfo"
                                            type="text"
                                            placeholder="Enter access info"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* </Tab>

                            </Tabs> */}
                        </Form>
                    </BootstrapModal.Body>

                    <BootstrapModal.Footer>
                        <Button
                            variant="secondary"
                            // disabled={isScheduling}
                            onClick={() => {
                                setShowDetailsModal(false);

                                setNewBuildingPhoto(null);
                                setNewBuildingLogo(null);

                                setHoverPhoto(false);
                                setHoverLogo(false);
                            }}
                        >
                            Cancel
                        </Button>


                        <Button variant="danger" onClick={handleSubmitDetails}>
                            Update Details
                        </Button>

                    </BootstrapModal.Footer>
                </BootstrapModal >

            </div >

            <BootstrapModal
                show={showMapModal}
                onHide={() => setShowMapModal(false)}
                dialogClassName="fullscreen-modal"
                aria-labelledby="fullscreen-map"
                centered={false}
                contentClassName="p-0"
                backdrop={true}
            >
                <div style={{ width: "100vw", height: "100vh", margin: 0, padding: 0, position: "relative" }}>
                    <button
                        className="
                            btn btn-danger
                            position-absolute
                            m-3
                            d-flex align-items-center justify-content-center
                            rounded-circle
                            "
                        style={{
                            width: "40px",
                            height: "40px",
                            zIndex: 1000,
                            top: "6px",
                            right: "10px",
                        }}
                        onClick={() => setShowMapModal(false)}
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>

                    <div style={{ position: "absolute", top: 20, left: 60, zIndex: 1000, width: "100%", maxWidth: "240px", }}>
                        <input
                            type="text"
                            placeholder="Search by Building, City, or Client Name..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "8px 12px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                                fontSize: "12px",
                            }}
                        />
                    </div>


                    {showMapModal && (
                        <MapContainer
                            center={locations.length ? [locations[0].lat, locations[0].lng] : [51.505, -0.09]}
                            zoom={10}
                            style={{ width: "100%", height: "100%" }}
                            preferCanvas={true}
                            attributionControl={false}
                            whenCreated={(map) => (mapRef.current = map)}
                        >
                            <MapRefresher trigger={showMapModal} />
                            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                            {locations
                                .filter((loc) => {
                                    const term = searchTerm.toLowerCase().trim();
                                    return (
                                        loc.name?.toLowerCase().includes(term) ||
                                        loc.city?.toLowerCase().includes(term) ||
                                        loc.clientName?.toLowerCase().includes(term)
                                    );
                                })
                                .map((loc) => (
                                    <Marker key={loc.id} position={[loc.lat, loc.lng]}>
                                        <Popup maxWidth={800} minWidth={300}>
                                            <div style={{ textAlign: "center", padding: "10px 15px" }}>
                                                <strong style={{ fontSize: "1.4rem", marginBottom: "10px", display: "block" }}>
                                                    {loc.name}
                                                </strong>

                                                {loc.buildingLink && (
                                                    <img
                                                        src={loc.buildingLink}
                                                        alt={loc.name}
                                                        style={{
                                                            width: "100%",
                                                            maxHeight: 250,
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            marginBottom: "15px",
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => {
                                                            handleReportClick(loc.id, loc, loc.totalFalseCount, loc.totalTrueCount);
                                                        }}
                                                    />
                                                )}

                                                {/* <div style={{ display: 'flex', justifyContent: 'space-around', gap: '15px', marginTop: '10px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                                                        <img src={greenDoor} style={{ height: 30 }} />
                                                        <span style={{ fontWeight: 'bold' }}>{loc.totalFalseCount || 0}</span>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                                                        <img src={redDoor} style={{ height: 30 }} />
                                                        <span style={{ fontWeight: 'bold' }}>{loc.totalTrueCount || 0}</span>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                                                        <img src={yellowDoor} style={{ height: 30 }} />
                                                        <span style={{ fontWeight: 'bold' }}>{loc.totalReqAttentionCount || 0}</span>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                                                        <img src={greyDoor} style={{ height: 30 }} />
                                                        <span style={{ fontWeight: 'bold' }}>{loc.totalHasAccessCount || 0}</span>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </Popup>
                                    </Marker>
                                ))
                            }

                            <FitBounds locations={locations} searchTerm={searchTerm} />

                        </MapContainer>
                    )}
                </div>
            </BootstrapModal>
            <BootstrapModal
                show={showCompare}
                onHide={() => {
                    setShowCompare(false);
                    setCompareResult(null);
                    setBuilding1("");
                    setBuilding2("");
                }}
                size="xl"
                centered
                backdrop="static"
                className="rounded-4"
            >
                <BootstrapModal.Header
                    closeButton
                    className="bg-gradient text-white border-0 pb-2"
                    style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    }}
                >
                    <BootstrapModal.Title className="fw-bold fs-4 text-black">
                        Compare Buildings
                    </BootstrapModal.Title>
                </BootstrapModal.Header>

                <BootstrapModal.Body className="p-4 bg-light" style={{ minHeight: "85vh" }}>
                    <div
                        className="d-flex align-items-center justify-content-between gap-3 mb-4 flex-nowrap"
                        style={{ width: '100%' }}
                    >
                        <div style={{ flex: '0 0 40%' }}>
                            <label className="form-label fw-semibold text-dark mb-2">First Building</label>
                            <Form.Select
                                value={building1}
                                onChange={(e) => setBuilding1(e.target.value)}
                                className="border-0 shadow-sm rounded-3"
                                style={{ height: '38px', fontSize: '0.95rem' }}
                            >
                                <option value="">Choose a building...</option>
                                {locations.map((b) => (
                                    <option key={b.id} value={b.id}>
                                        {b.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>

                        <div style={{ flex: '0 0 15%', paddingTop: '28px' }}>
                            <Button
                                variant="outline-dark"
                                onClick={handleCompare}
                                className="w-100 fw-semibold rounded-3 shadow-sm"
                                style={{ height: '38px', fontSize: '0.9rem', whiteSpace: 'nowrap' }}
                            >
                                Compare
                            </Button>
                        </div>

                        <div style={{ flex: '0 0 40%' }}>
                            <label className="form-label fw-semibold text-dark mb-2">Second Building</label>
                            <Form.Select
                                value={building2}
                                onChange={(e) => setBuilding2(e.target.value)}
                                className="border-0 shadow-sm rounded-3"
                                style={{ height: '38px', fontSize: '0.95rem' }}
                            >
                                <option value="">Choose a building...</option>
                                {locations.map((b) => (
                                    <option key={b.id} value={b.id}>
                                        {b.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>

                    {compare && compareResult && (
                        <div className="row g-3 mt-3">
                            {compareResult.loc1 && (
                                <div className="col-md-6">
                                    <div
                                        className="p-2 border-0 rounded-4 shadow-sm bg-white d-flex align-items-stretch mb-3"
                                        style={{ height: '260px', overflow: 'hidden' }}
                                    >
                                        <div
                                            style={{
                                                flex: '0 0 20%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                gap: '6px',
                                            }}
                                        >
                                            {[
                                                { img: greenDoor, color: 'danger', count: compareResult.loc1.totalFalseCount },
                                                { img: redDoor, color: 'success', count: compareResult.loc1.totalTrueCount },
                                                { img: yellowDoor, color: 'warning', count: compareResult.loc1.totalReqAttentionCount },
                                                { img: greyDoor, color: 'secondary', count: compareResult.loc1.totalHasAccessCount },
                                            ].map((item, i) => (
                                                <div
                                                    key={i}
                                                    className="rounded-3 d-flex flex-row align-items-center justify-content-center bg-light shadow-sm gap-2"
                                                    style={{
                                                        flex: '1',
                                                        width: '90%',
                                                        minHeight: '0',
                                                    }}
                                                >
                                                    <img src={item.img} alt="" style={{ height: '28px', marginBottom: '4px' }} />
                                                    <div className={`fw-bold text-${item.color}`} style={{ fontSize: '1rem' }}>
                                                        {item.count || 0}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div
                                            style={{
                                                flex: '0 0 80%',
                                                paddingLeft: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <img
                                                src={compareResult.loc1.buildingLink}
                                                alt=""
                                                className="rounded-3 shadow-sm"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="p-3 border-0 rounded-4 shadow-sm bg-white">
                                        <h6 className="fw-bold text-danger mb-3">Issues & Work Needed - {compareResult.loc1.name}</h6>

                                        <div className="d-flex mb-3 border-bottom">
                                            <button
                                                className={`btn btn-sm me-2 ${activeTab1 === 'issues' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                onClick={() => setActiveTab1('issues')}
                                            >
                                                Issues ({getCombinedIssues(compareResult.loc1, data).filter(issue => issue.category !== 'Work Needed').length})
                                            </button>
                                            <button
                                                className={`btn btn-sm ${activeTab1 === 'work' ? 'btn-warning' : 'btn-outline-warning'}`}
                                                onClick={() => setActiveTab1('work')}
                                            >
                                                Work Needed ({getCombinedIssues(compareResult.loc1, data).filter(issue => issue.category === 'Work Needed').length})
                                            </button>
                                        </div>

                                        <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                            {activeTab1 === 'issues' && (
                                                <>
                                                    {getCombinedIssues(compareResult.loc1, data).filter(issue => issue.category !== 'Work Needed').length > 0 ? (
                                                        getCombinedIssues(compareResult.loc1, data)
                                                            .filter(issue => issue.category !== 'Work Needed')
                                                            .map((issue, index) => (
                                                                <div key={index} className="mb-3 p-2 border rounded-2 bg-light">
                                                                    <h6 className="fw-bold text-danger mb-2" style={{ fontSize: '0.9rem' }}>
                                                                        {issue.category}
                                                                        <span className="badge bg-danger ms-2">{issue.count} doors</span>
                                                                    </h6>
                                                                    <div className="small text-dark">
                                                                        {issue.description}
                                                                    </div>
                                                                    {issue.doors.length > 0 && (
                                                                        <div className="mt-2">
                                                                            <small className="text-muted fw-bold">Affected doors:</small>
                                                                            <div className="mt-1">
                                                                                {issue.doors.map((door, doorIndex) => (
                                                                                    <span key={doorIndex} className="badge bg-secondary me-1 mb-1" style={{ fontSize: '0.7rem' }}>
                                                                                        {door.doorName || door.roomName || 'Unknown'}
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))
                                                    ) : (
                                                        <div className="text-center text-muted py-3">
                                                            <small>No issues found for this building</small>
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            {activeTab1 === 'work' && (
                                                <>
                                                    {getCombinedIssues(compareResult.loc1, data).filter(issue => issue.category === 'Work Needed').length > 0 ? (
                                                        getCombinedIssues(compareResult.loc1, data)
                                                            .filter(issue => issue.category === 'Work Needed')
                                                            .map((issue, index) => (
                                                                <div key={index} className="mb-3 p-2 border rounded-2 bg-light">
                                                                    <h6 className="fw-bold text-warning mb-2" style={{ fontSize: '0.9rem' }}>
                                                                        Work Needed
                                                                        <span className="badge bg-warning ms-2">{issue.count} doors</span>
                                                                    </h6>
                                                                    <div className="small text-dark">
                                                                        {issue.description}
                                                                    </div>
                                                                    {issue.doors.length > 0 && (
                                                                        <div className="mt-2">
                                                                            <small className="text-muted fw-bold">Affected doors:</small>
                                                                            <div className="mt-1">
                                                                                {issue.doors.map((door, doorIndex) => (
                                                                                    <span key={doorIndex} className="badge bg-secondary me-1 mb-1" style={{ fontSize: '0.7rem' }}>
                                                                                        {door.doorName || door.roomName || 'Unknown'}
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))
                                                    ) : (
                                                        <div className="text-center text-muted py-3">
                                                            <small>No work needed for this building</small>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {compareResult.loc2 && (
                                <div className="col-md-6">
                                    <div
                                        className="p-2 border-0 rounded-4 shadow-sm bg-white d-flex align-items-stretch mb-3"
                                        style={{ height: '260px', overflow: 'hidden' }}
                                    >
                                        <div
                                            style={{
                                                flex: '0 0 20%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                gap: '6px',
                                            }}
                                        >
                                            {[
                                                { img: greenDoor, color: 'danger', count: compareResult.loc2.totalFalseCount },
                                                { img: redDoor, color: 'success', count: compareResult.loc2.totalTrueCount },
                                                { img: yellowDoor, color: 'warning', count: compareResult.loc2.totalReqAttentionCount },
                                                { img: greyDoor, color: 'secondary', count: compareResult.loc2.totalHasAccessCount },
                                            ].map((item, i) => (
                                                <div
                                                    key={i}
                                                    className="rounded-3 d-flex flex-row align-items-center justify-content-center bg-light shadow-sm gap-2"
                                                    style={{
                                                        flex: '1',
                                                        width: '90%',
                                                        minHeight: '0',
                                                    }}
                                                >
                                                    <img src={item.img} alt="" style={{ height: '28px', marginBottom: '4px' }} />
                                                    <div className={`fw-bold text-${item.color}`} style={{ fontSize: '1rem' }}>
                                                        {item.count || 0}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div
                                            style={{
                                                flex: '0 0 80%',
                                                paddingLeft: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <img
                                                src={compareResult.loc2.buildingLink}
                                                alt=""
                                                className="rounded-3 shadow-sm"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="p-3 border-0 rounded-4 shadow-sm bg-white">
                                        <h6 className="fw-bold text-primary mb-3">Issues & Work Needed - {compareResult.loc2.name}</h6>

                                        <div className="d-flex mb-3 border-bottom">
                                            <button
                                                className={`btn btn-sm me-2 ${activeTab2 === 'issues' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => setActiveTab2('issues')}
                                            >
                                                Issues ({getCombinedIssues(compareResult.loc2, data).filter(issue => issue.category !== 'Work Needed').length})
                                            </button>
                                            <button
                                                className={`btn btn-sm ${activeTab2 === 'work' ? 'btn-warning' : 'btn-outline-warning'}`}
                                                onClick={() => setActiveTab2('work')}
                                            >
                                                Work Needed ({getCombinedIssues(compareResult.loc2, data).filter(issue => issue.category === 'Work Needed').length})
                                            </button>
                                        </div>

                                        <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                            {activeTab2 === 'issues' && (
                                                <>
                                                    {getCombinedIssues(compareResult.loc2, data).filter(issue => issue.category !== 'Work Needed').length > 0 ? (
                                                        getCombinedIssues(compareResult.loc2, data)
                                                            .filter(issue => issue.category !== 'Work Needed')
                                                            .map((issue, index) => (
                                                                <div key={index} className="mb-3 p-2 border rounded-2 bg-light">
                                                                    <h6 className="fw-bold text-primary mb-2" style={{ fontSize: '0.9rem' }}>
                                                                        {issue.category}
                                                                        <span className="badge bg-primary ms-2">{issue.count} doors</span>
                                                                    </h6>
                                                                    <div className="small text-dark">
                                                                        {issue.description}
                                                                    </div>
                                                                    {issue.doors.length > 0 && (
                                                                        <div className="mt-2">
                                                                            <small className="text-muted fw-bold">Affected doors:</small>
                                                                            <div className="mt-1">
                                                                                {issue.doors.map((door, doorIndex) => (
                                                                                    <span key={doorIndex} className="badge bg-secondary me-1 mb-1" style={{ fontSize: '0.7rem' }}>
                                                                                        {door.doorName || door.roomName || 'Unknown'}
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))
                                                    ) : (
                                                        <div className="text-center text-muted py-3">
                                                            <small>No issues found for this building</small>
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            {activeTab2 === 'work' && (
                                                <>
                                                    {getCombinedIssues(compareResult.loc2, data).filter(issue => issue.category === 'Work Needed').length > 0 ? (
                                                        getCombinedIssues(compareResult.loc2, data)
                                                            .filter(issue => issue.category === 'Work Needed')
                                                            .map((issue, index) => (
                                                                <div key={index} className="mb-3 p-2 border rounded-2 bg-light">
                                                                    <h6 className="fw-bold text-warning mb-2" style={{ fontSize: '0.9rem' }}>
                                                                        Work Needed
                                                                        <span className="badge bg-warning ms-2">{issue.count} doors</span>
                                                                    </h6>
                                                                    <div className="small text-dark">
                                                                        {issue.description}
                                                                    </div>
                                                                    {issue.doors.length > 0 && (
                                                                        <div className="mt-2">
                                                                            <small className="text-muted fw-bold">Affected doors:</small>
                                                                            <div className="mt-1">
                                                                                {issue.doors.map((door, doorIndex) => (
                                                                                    <span key={doorIndex} className="badge bg-secondary me-1 mb-1" style={{ fontSize: '0.7rem' }}>
                                                                                        {door.doorName || door.roomName || 'Unknown'}
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))
                                                    ) : (
                                                        <div className="text-center text-muted py-3">
                                                            <small>No work needed for this building</small>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </BootstrapModal.Body>
            </BootstrapModal>
        </div >
    );
};


export default Buildings;
